module.exports = {
  "header": {
    "text1": "Flight Platform",
    "cpList": [
      {
        "title": "Unmanned Helicopter",
        "list": [
          {
            "name": "HW-600H",
            "router": "/hw600"
          },
          {
            "name": "HW-25H",
            "router": "/hw25h"
          }
        ]
      },
      {
        "title": "Compound - wing UAV",
        "list": [
          {
            "name": "ZT-120V",
            "router": "/zt120v"
          },
          {
            "name": "ZT-60VS",
            "router": "/zt60vs"
          },
          {
            "name": "ZT-60V",
            "router": "/zt60v"
          },
          {
            "name": "ZT-25VS",
            "router": "/zt25vs"
          },
          {
            "name": "ZT-25V",
            "router": "/zt25v"
          },
          {
            "name": "ZT-16V",
            "router": "/zt16v"
          },
          {
            "name": "ZT-13V",
            "router": "/zt13v"
          }
        ]
      }
    ],
    "routerList1": [
      {
        "title": "Mission Payload",
        "list": [
          {
            "name": "Electro - optical Pod",
            "router": "/gddc"
          },
          {
            "name": "Surveying Camera",
            "router": "/chxj"
          },
          {
            "name": "Lidar",
            "router": "/jgld"
          }
        ]
      },
      {
        "title": "Ground Equipment",
        "list": [
          {
            "name": "Portable Control Station",
            "router": "/dmsb"
          },
          {
            "name": "Dual - screen Control Station",
            "router": "/dmsb2"
          },
          {
            "name": "Roaming Data Link",
            "router": "/dmsb3"
          },
          {
            "name": "Relay Data Link",
            "router": "/dmsb4"
          }
        ]
      },
      {
        "title": "Software Products",
        "list": [
          {
            "name": "Inspection Assistant",
            "router": "/rjcp"
          },
          {
            "name": "Dowell",
            "router": "/rjcp2"
          },
          {
            "name": "Cloud Patrol",
            "router": "/rjcp3"
          }
        ]
      }
    ],
    "routerList2": [
      {
        "title": "Simulation",
        "list": [
          {
            "name": "Simulation Trainer",
            "router": "/fzxt"
          }
        ]
      },
      {
        "title": "Unmanned Airdrome",
        "list": [
          {
            "name": "Cloud Patrol Unattended System",
            "router": "/yxxt"
          }
        ]
      },
      {
        "title": "",
        "list": []
      }
    ],
    "list": [
      {
        "title": "Industry Solutions",
        "id": "1",
        "children": {
          "isHv": 0,
          "list": [
            {
              "id": "5-2",
              "parentMenuId": "5",
              "state": "TEXT",
              "name": "After Sales",
              "alias": "Emergency",
              "link": "/fayj",
              "discription": ""
            },
            {
              "id": "5-1",
              "parentMenuId": "5",
              "state": "TEXT",
              "name": "About",
              "alias": "Energy",
              "link": "/fany",
              "discription": ""
            },
            {
              "id": "5-1",
              "parentMenuId": "5",
              "state": "TEXT",
              "name": "About",
              "alias": "Forestry and Grassland",
              "link": "/falc",
              "discription": ""
            },
            {
              "id": "5-1",
              "parentMenuId": "5",
              "state": "TEXT",
              "name": "About",
              "alias": "Public Security",
              "link": "/faga",
              "discription": ""
            },
            {
              "id": "5-1",
              "parentMenuId": "5",
              "state": "TEXT",
              "name": "About",
              "alias": "Surveying and Mapping",
              "link": "/fach",
              "discription": ""
            },
            {
              "id": "5-1",
              "parentMenuId": "5",
              "state": "TEXT",
              "name": "About",
              "alias": "Water Conservancy",
              "link": "/fasl",
              "discription": ""
            }
          ]
        }
      },
      {
        "id": "2",
        "title": "Product Center",
        "children": {
          "list": []
        }
      },
      {
        "id": "7",
        "title": "News and Trends",
        "target": "self",
        "link": "/hyxw"
      },
      {
        "title": "About Us",
        "id": "5",
        "children": {
          "isHv": 0,
          "list": [
            {
              "id": "5-1",
              "parentMenuId": "5",
              "state": "TEXT",
              "name": "About",
              "alias": "Company Profile",
              "link": "/join",
              "discription": "Company Profile"
            },
            // {
            //   "id": "5-2",
            //   "parentMenuId": "5",
            //   "state": "TEXT",
            //   "name": "After Sales",
            //   "alias": "Join Us",
            //   "link": "/join2",
            //   "discription": "Enterprise Introduction"
            // }
          ]
        }
      },
      {
        "id": "6",
        "title": "Contact Us",
        "target": "self",
        "link": "/contactUs"
      }
    ],
    "listM": [
      {
        "title": "Industry Solutions",
        "id": "2",
        "children": {
          "isHv": 0,
          "list": [
            {
              "title": "Solutions",
              "state": "SORT",
              "list": [
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Emergency Response",
                  "alias": "Emergency Response",
                  "link": "/fayj",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Energy",
                  "alias": "Energy",
                  "link": "/fany",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Forestry and Grassland",
                  "alias": "Forestry and Grassland",
                  "link": "/falc",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Public Security",
                  "alias": "Public Security",
                  "link": "/faga",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Surveying and Mapping",
                  "alias": "Surveying and Mapping",
                  "link": "/fach",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Water Resources",
                  "alias": "Water Resources",
                  "link": "/fasl",
                  "img": "",
                  "discription": ""
                }
              ]
            }
          ]
        }
      },
      {
        "title": "Product Center",
        "id": "2",
        "children": {
          "isHv": 0,
          "list": [
            {
              "title": "Unmanned Helicopters",
              "state": "SORT",
              "list": [
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "HW-600H",
                  "alias": "HW-600H",
                  "link": "/hw600",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "HW-25H",
                  "alias": "HW-25H",
                  "link": "/hw25h",
                  "img": "",
                  "discription": ""
                }
              ]
            },
            {
              "title": "Hybrid Wing UAVs",
              "state": "SORT",
              "list": [
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "ZT-120V",
                  "alias": "ZT-120V",
                  "link": "/zt120v",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "ZT-60VS",
                  "alias": "ZT-60VS",
                  "link": "/zt60vs",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "ZT-60V",
                  "alias": "ZT-60V",
                  "link": "/zt60v",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "ZT-25VS",
                  "alias": "ZT-25VS",
                  "link": "/zt25vs",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "ZT-25V",
                  "alias": "ZT-25V",
                  "link": "/zt25v",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "ZT-16V",
                  "alias": "ZT-16V",
                  "link": "/zt16v",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "ZT-13V",
                  "alias": "ZT-13V",
                  "link": "/zt13v",
                  "img": "",
                  "discription": ""
                }
              ]
            },
            {
              "title": "Mission Payloads",
              "state": "SORT",
              "list": [
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Optoelectronic Pods",
                  "alias": "Optoelectronic Pods",
                  "link": "/gddc",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Surveying Cameras",
                  "alias": "Surveying Cameras",
                  "link": "/chxj",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Lidar",
                  "alias": "Lidar",
                  "link": "/jgld",
                  "img": "",
                  "discription": ""
                }
              ]
            },
            {
              "title": "Ground Equipment",
              "state": "SORT",
              "list": [
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Portable Control Stations",
                  "alias": "Portable Control Stations",
                  "link": "/dmsb",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Dual-Screen Control Stations",
                  "alias": "Dual-Screen Control Stations",
                  "link": "/dmsb2",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Roaming Data Links",
                  "alias": "Roaming Data Links",
                  "link": "/dmsb3",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Relay Data Links",
                  "alias": "Relay Data Links",
                  "link": "/dmsb4",
                  "img": "",
                  "discription": ""
                }
              ]
            },
            {
              "title": "Software Products",
              "state": "SORT",
              "list": [
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Inspection Assistant",
                  "alias": "Inspection Assistant",
                  "link": "/rjcp",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Dowell",
                  "alias": "Dowell",
                  "link": "/rjcp2",
                  "img": "",
                  "discription": ""
                },
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Cloud Inspection",
                  "alias": "Cloud Inspection",
                  "link": "/rjcp3",
                  "img": "",
                  "discription": ""
                }
              ]
            },
            {
              "title": "Simulation",
              "state": "SORT",
              "list": [
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Simulation Training Devices",
                  "alias": "Simulation Training Devices",
                  "link": "/fzxt",
                  "img": "",
                  "discription": ""
                }
              ]
            },
            {
              "title": "Unmanned Airports",
              "state": "SORT",
              "list": [
                {
                  "id": "2-2",
                  "parentMenuId": "2",
                  "name": "Cloud patrol unattended UAS Docking Station",
                  "alias": "Cloud patrol unattended UAS Docking Station",
                  "link": "/yxxt",
                  "img": "",
                  "discription": ""
                }
              ]
            }
          ]
        }
      },
      {
        "title": "News and Updates",
        "id": "6",
        "target": "self",
        "link": "/hyxw"
      },
      {
        "title": "About Us",
        "id": "7",
        "children": {
          "isHv": 0,
          "list": [
            {
              "id": "6-1",
              "parentMenuId": "6",
              "state": "TEXT",
              "name": "Campus",
              "alias": "Company Profile",
              "link": "/join",
              "discription": "Company Profile"
            },
            {
              "id": "6-2",
              "parentMenuId": "6",
              "state": "TEXT",
              "name": "Social",
              "alias": "Join Us",
              "link": "/join2",
              "discription": "Join Us"
            }
          ]
        }
      },
      {
        "title": "Contact Us",
        "id": "7",
        "state": "TEXT",
        "link": "/contactUs",
        "discription": "Contact Us"
      },
      {
        "title": "中文/EN",
        "id": "8",
        "children": {
          "isHv": 0,
          "list": [
            {
              "id": "8-1",
              "parentMenuId": "6",
              "state": "OTHER",
              "alias": "Chinese",
              "discription": "zh_CN"
            },
            {
              "id": "8-2",
              "parentMenuId": "6",
              "state": "OTHER",
              "alias": "English",
              "discription": "en_US"
            }
          ]
        }
      }
    ],
    "assistInfo": {
      "lang": "CN",
      "login": "login",
      "register": "register",
      "href": "/"
    }
  },
  'footer': [
    {
      'titleZH': 'Contact us',
      'titleEN': 'Contact us',
      'children': [
        // {
        //   'name': 'about us',
        //   'target': 'self',
        //   'href': '/about-us'
        // },
        {
          'name': 'company profile',
          'target': 'self',
          'href': '/join'
        },
        {
          'name': 'contact us',
          'target': 'self',
          'href': '/contactUs'
        }
      ]
    },
    {
      'titleZH': 'technical support',
      'titleEN': 'Support',
      'children': [
        {
          'name': 'help and support',
          'target': 'self',
          'href': '/after-sale'
        }
      ]
    },
    {
      'titleZH': 'Join us',
      'titleEN': 'Join us',
      'children': [
        {
          'name': 'Join us',
          'target': 'self',
          'href': '/join2'
        },
        {
          'name': 'Social Recruitment',
          'target': 'self',
          'href': '/social'
        },
        {
          'name': 'Campus recruitment',
          'target': 'self',
          'href': '/campus'
        }
      ]
    }
  ],
  'foot1':{
    'text1':'After sales phone',
    'text2':'Business Consulting',
  },
  // caogt添加

  'com_banner': {
    "banner": [
      {
        "neme1": "Unmanned Helicopter",
        "text1": "HW-600H",
        "neme2": "Payload",
        "text2": "200+kg",
        "neme3": "Endurance",
        "text3": "8h",
        "neme4": "Video Transmission",
        "text4": "300km",
        "info": "HW-600H is a large - payload, long - endurance transport unmanned helicopter. Its power system uses an independent and controllable gasoline engine. The fuselage adopts a tandem layout, which is compact in structure and high in payload efficiency. The avionics equipment uses a triple - redundant safety flight control system, equipped with a dual - navigation system of satellite navigation and visual - aided navigation. Combined with an autonomous obstacle - avoidance system based on LiDAR, it fully ensures flight safety.",
        "url": "/static/images/v2/600h/600h_bg1.png",
        "h5url": "/static/images/v2/600h/600h_bg1.png",
        "color": "#fff",
        "href": ""
      },
      {
        "neme1": "Hybrid - electric Vertical Takeoff and Landing Fixed - wing UAV",
        "text1": "ZT-120V",
        "neme2": "Payload Capacity",
        "text2": "40kg",
        "neme3": "Endurance",
        "text3": "10h",
        "neme4": "Extendable Control Range",
        "text4": "300+km",
        "info": "The ZT - 120V UAV is an industry - leading product specifically developed for aviation emergency rescue scenarios. It adopts a compound - wing layout that combines a fixed - wing and multi - rotors. This UAV is compatible with a full set of emergency - scenario payloads, can quickly complete aerial reconnaissance and communication support tasks, has all - weather 3D modeling and rapid mapping capabilities, providing strong support and guarantee for emergency rescue work.",
        "url": "/static/images/v2/120v/120v_bg1.png",
        "h5url": "/static/images/v2/120v/120v_bg1.png",
        "color": "#fff",
        "href": ""
      },
      {
        "neme1": "Compound - wing UAV",
        "text1": "ZT-13V",
        "neme2": "",
        "text2": "",
        "neme3": "Payload Capacity",
        "text3": "3kg",
        "neme4": "Endurance",
        "text4": "200min",
        "info": "The ZT - 13V adopts a pure - electric drive mode. With a payload capacity of 3kg and an endurance of 200 minutes, and a maximum range of 180km, it is a UAV specifically suitable for unmanned airports.",
        "url": "/static/images/v2/13v/13v_bg1.png",
        "h5url": "/static/images/v2/13v/13v_bg1.png",
        "color": "#fff",
        "href": ""
      }
    ]
  },
  'com_meters': {
    'text1': 'Solution Customization Expert',
    'text2': 'view',
    'text3': 'close',
  },
  'com_application': {
    'list': [
      {
        'label': "for police",
        'img': "/static/images/industry/application/1.png"
      },
      {
        'label': "survey ",
        'img': "/static/images/industry/application/2.png"
      },
      {
        'label': "petroleum",
        'img': "/static/images/industry/application/3.png"
      },
      {
        'label': "power",
        'img': "/static/images/industry/application/4.png"
      },
      {
        'label': "emergency",
        'img': "/static/images/industry/application/5.png"
      },
      {
        'label': "environmental",
        'img': "/static/images/industry/application/6.png"
      },
      {
        'label': "maritime affairs",
        'img': "/static/images/industry/application/7.png"
      }
    ]
  },

  'about_after': {
    'help': 'Help and Support'

  },
  'about_company': {
    'name-1': 'company Profile',
    'name': 'HOVER WING',
    'intro': 'Focusing on the research, development and production of large payload unmanned helicopters, we are committed to providing customers with professional solutions for the unmanned helicopter industry.',
    'title1': '15years+ Core technology accumulation',
    'title2': 'Chip-scale drone development and mass production capabilities',
    'title3': 'Integration capacity of the whole industry chain',
    'title4': 'More than ten years of technology research and development accumulation',
    'title5': 'focusing on the research and promotion of practical UAV technology',
    'desc1': 'The founding team has been engaged in the UAV industry for more than fifteen years, focusing on key technologies such as flight control, data chain, payload, machine vision, etc., and possesses technical advantages',
    'desc2': 'The team is the only one in the industry that has accumulated more than 200,000 drones in production and sales, and has the ability to develop and mass produce chip-level drones',
    'desc3': 'The key technologies of UAV are all independently researched and developed, with the ability to integrate the whole industry chain，Integration capacity of the whole industry chain',
    'desc4': '',
    'desc5': '',
    'desc6': 'The company has formed a variety of mature product lines, including unmanned helicopter specialized avionics products and heavy-duty helicopters. The core product of heavy-duty unmanned helicopters is highly integrated with multiple unmanned aerial vehicle technologies, with advantages such as high payload, long endurance, multiple hanging points, rich delivery methods, large loading space, and long-term hovering ability. Compared with similar products, it has stronger performance, lower cost, and high cost-effectiveness, and can be widely used in material transportation, emergency, power, and other fields Multiple fields such as border defense and petroleum. The company currently has multiple stable customers including government, central enterprises, and overseas, and the market is growing steadily',
  },
  'about_contact': {
    'tell_me': 'Tell us about your needs',
    'text1': 'You can tell us about your needs in the following ways, our sales consultants will provide you with professional assistance tailored to your needs',
    'text2': 'INNOVATIVE BUSINESS',
    'text3': 'Exploration and operation hosting services for cutting-edge applications of industrial drones in energy, military, scientific research, etc',
    'text4': 'Company Address',
    'text5': '航翊科技',
    'text6': '北京市海淀区华胜天成科研大楼一层东侧101-102',
  },
  'about_index': {
    'text1': 'About us',
    'text2': 'Learn about the HOVER WING',
    'text3': 'HOVER WING Technology is composed of a group of young people who have dreams, vigor, passion, and the courage to innovate.',
    'text4': 'HOVER WING is dedicated to "empowering industrial applications with drone and artificial intelligence technology"”',
    'text4-1':' and promoting the innovation and development of production methods',
    'text5': 'Specialized in the technical research and promotion of large-load unmanned helicopters',
    'text5-1': 'Focusing on practical technology research and promotion of drones',
    'text6': 'Further understanding of our technology and research and development accumulation',
    'text7': 'Technical territory and R&D accumulation',
    'text8': '“Respect,inclusiveness,development”',
    'text9': 'Strive to provide a platform for every outstanding talent who joins us to showcase their talents and a stage for realizing their life values and dreams',
    'text10': '“Craftsmanship,pragmatism,innovation”',
    'text11': 'Craftsmanship, pragmatism, and innovation adhere to the corporate philosophy of "craftsmanship, pragmatism, and innovation". Starting from the real needs of users, we actively explore the vast application scenarios and infinite possibilities of drones in social production, and are committed to empowering industry applications with the cutting-edge drones and artificial intelligence technology, promoting the continuous innovation and development of production methods.',
    'text12':'Learn about the HOVER WING',
    'list': [
      {
        'title': "technologies",
        'desc': "R&D of UAV products, solutions and key technologies",
        'img': "/static/images/about/about/yanfa.png",
        'alt': "technologies"
      },
      {
        'title': "Sales",
        'desc': "Sales of complete UAV products, avionics systems and payloads",
        'img': "/static/images/about/about/xiaoshou.png",
        'alt': "Sales"
      },
      {
        'title': "services",
        'desc': "UAV business hosting operations and integrated technical services",
        'img': "/static/images/about/about/fuwu.png",
        'alt': "services"
      },
      {
        'title': "ODM",
        'desc': "Customization of UAV product needs and ODM",
        'img': "/static/images/about/about/ODM.png",
        'alt': "ODM"
      }
      // {
      //   title: "编队",
      //   desc: "无人机编队表演和技术方案输出",
      //   img: "/static/images/about/about/biandui.png",
      //   alt: "编队"
      // }
    ]
  },
  //--------------
  'avionics_diatal': {
    'text1': 'Digital, image-integrated data chain',
    'text2': 'Small size, light weight, long-distance transmission, low latency',
    'text3': 'Multi channel integration, flexible expansion',
    'text4': 'It can simultaneously access image links, data links, differential GPS correction links, S-BUS links, etc., with flexible expansion and powerful functions',
    'text5': 'Dedicated video with low power and high efficiency',
    'text6': '1.4GHz drone dedicated frequency, with a transmission distance of up to 30Km and a power as low as 0.5W, in compliance with the frequency regulations of the Ministry of Industry and Information Technology for drone piloting aircraft systems.',
    'text7': 'High definition imaging, as if in person',
    'text8': 'The equipped visible light camera has 30x optical zoom capability, high-definition imaging, and breaks through visual constraints.',
    'text9': 'High definition image quality, exquisite and exquisite',
    'text10': 'HDMI high-definition signal input, H.264 image compression method,',
    'text11': 'A wide range of applications',
    'text12': 'It can be used in remote sensing aerial surveys, maritime cruising, electric cruising, highway detection, border patrol, forest fire prevention, environmental detection, agricultural meteorology, military reconnaissance, pipeline inspection, urban emergency response and other fields.',
    'text13': 'Solution Customization Expert',
    'text14': 'view',
    'text15': 'close',
    'text16': 'sales hotline：010-58650999',
    'text17': 'Email：public@aeronitor.com',
  },
  'avionics_gimbal': {
    'applicationTitle': "Applicable to multiple unmanned vehicles",
    'tel': "Mr Kong：13240113344",
    'email': "Email：public@aeronitor.com",
    'text1': 'HW-Gimbal Series Optical Pods',
    'text2': 'Specialized in providing complete solutions for all types of high-level drones',
    'text3': 'HW-Gimbal series optoelectronic pods are specially developed for high-level UAV platforms, integrating advanced drive control algorithms, adopting three-axis mechanical stabilization technology with stabilization accuracy of ±0.02°, and matching with on-board AI module to achieve fast detection and stable tracking of moving targets. According to the application scenarios, the HW-Gimbal system optoelectronic pods are integrated with visible, thermal infrared, laser and other optoelectronic units to expand PAD control terminals and dual-screen ground stations. According to the application scenarios, HW-Gimbal system optoelectronic pod integrates visible light, thermal infrared, laser and other optoelectronic units, and can expand PAD control terminal and dual-screen ground station, which is widely used in the aerial operation scenarios of unmanned aerial vehicles such as investigation and forensic evidence collection, emergency rescue, line inspection, and border patrol.',
    'text4': 'HW-Gimbal Series Optical Pods Featured Benefits',
    'text5': 'Product parameters',
    'text6': 'view',
    'text7': 'close',
    'text8': 'HW-Gimbal Series Optical Pods (part)',
    'applyData': [
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "Three-axis mechanical stabilization, always stable",
        'desc': "Integration of advanced drive control algorithms, the use of three-axis mechanical stabilization technology, cruise stabilization accuracy ± 0.02 °, any angle can maintain the field of view level stability;",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "Three-axis mechanical stabilization, always stable"
      },
      {
        'type': '0',
        'title': "Low wind resistance spherical shape with 45° downward tilting of the horizontal roll axis",
        'desc': "Adopting low wind resistance spherical appearance, hidden frame design, innovative use of horizontal roll axis downward tilted 45 ° structural design, maximize the fit of the UAV cruising attitude;",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "Low wind resistance spherical shape with 45° downward tilting of the horizontal roll axis"
      },
      {
        'type': '0',
        'title': "Self-original, small size, light weight, widely applicable",
        'desc': "Independent original research and development, with complete intellectual property rights, lightweight structure design, with small size, light weight, widely applicable advantages;",
        'img': "/static/images/avionics/common/application3.jpg",
        'alt': "Self-original, small size, light weight, widely applicable"
      },
      {
        'type': '0',
        'title': "Support Expanding AI Artificial Intelligence to Empower Efficient Productivity",
        'desc': "It supports the expansion of the AI artificial intelligence module on the airborne side, realizing AI target intelligent recognition, target locking automatic tracking, AR data real-time overlay, etc., empowering efficient productivity;",
        'img': "/static/images/avionics/common/application4.jpg",
        'alt': "Support Expanding AI Artificial Intelligence to Empower Efficient Productivity"
      },
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "Good compatibility, can be expanded to high-level avionics complete solutions",
        'desc': "Good compatibility, support for third-party avionics, expandable to higher-order avionics complete solutions, cost-effective, and also enables normal operation under satellite denial conditions;",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "Good compatibility, can be expanded to high-level avionics complete solutions"
      },
      {
        'type': '0',
        'title': "Support customized development for more possibilities",
        'desc': "Support customized photoelectric unit and handheld PAD control terminal, compatible with a variety of data chains, to meet the needs of personalized customization, widely applicable;",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "Support customized development for more possibilities"
      }
    ],
    "tb_txt1": "Product model",
    "tb_txt2": "G10T - 30X",
    "tb_txt3": "G20T - 30X35",
    "tb_txt4": "G30T - 30X35L10",
    "tb_txt5": "Dimensions | Weight",
    "tb_txt6": "Diameter: 100 mm; Height: 154 mm; Weight: 530 g",
    "tb_txt7": "Diameter: 110 mm; Height: 160.7 mm; Weight: 630 g",
    "tb_txt8": "Diameter: 122 mm; Height: 172.4 mm; Weight: 660 g",
    "tb_txt9": "Power consumption",
    "tb_txt10": "Normal ≤ 11.5 W, Peak ≤ 43 W",
    "tb_txt11": "Normal ≤ 11.7 W, Peak ≤ 49 W",
    "tb_txt12": "Normal ≤ 9.8 W, Peak ≤ 49 W",
    "tb_txt13": "Stabilization type",
    "tb_txt14": "Three - axis mechanical stabilization",
    "tb_txt15": "Three - axis mechanical stabilization",
    "tb_txt16": "Three - axis mechanical stabilization",
    "tb_txt17": "Pitch | Heading | Roll",
    "tb_txt18": "+45° to - 135° | 360° x n | +60° to - 60°",
    "tb_txt19": "+45° to - 135° | 360° x n | +60° to - 60°",
    "tb_txt20": "+45° to - 135° | 360° x n | +60° to - 60°",
    "tb_txt21": "Stabilization performance",
    "tb_txt22": "±0.02°",
    "tb_txt23": "±0.02°",
    "tb_txt24": "±0.02°",
    "tb_txt25": "Visible light",
    "tb_txt26": "Lens",
    "tb_txt27": "30x optical zoom; Focal length: 4.3 - 129 mm; F1.6 - 4.7",
    "tb_txt28": "30x optical zoom; Focal length: 4.3 - 129 mm; F1.6 - 4.7",
    "tb_txt29": "30x optical zoom; Focal length: 4.3 - 129 mm; F1.6 - 4.7",
    "tb_txt30": "Sensor",
    "tb_txt31": "Sony star - light - level CMOS",
    "tb_txt32": "Sony star - light - level CMOS",
    "tb_txt33": "Sony star - light - level CMOS",
    "tb_txt34": "Image",
    "tb_txt35": "FHD, 1080P @ 30 fps",
    "tb_txt36": "FHD, 1080P @ 30 fps",
    "tb_txt37": "FHD, 1080P @ 30 fps",
    "tb_txt38": "FOV",
    "tb_txt39": "63.7° (wide - angle end) to 2.3° (telephoto end)",
    "tb_txt40": "63.7° (wide - angle end) to 2.3° (telephoto end)",
    "tb_txt41": "63.7° (wide - angle end) to 2.3° (telephoto end)",
    "tb_txt42": "Thermal infrared",
    "tb_txt43": "Resolution",
    "tb_txt44": "N/A",
    "tb_txt45": "640 x 512, 12μm pixel",
    "tb_txt46": "640 x 512, 12μm pixel",
    "tb_txt47": "Type",
    "tb_txt48": "N/A",
    "tb_txt49": "Uncooled vanadium oxide focal plane array, 8 - 14μm",
    "tb_txt50": "Uncooled vanadium oxide focal plane array, 8 - 14μm",
    "tb_txt51": "Focal length",
    "tb_txt52": "N/A",
    "tb_txt53": "35 mm",
    "tb_txt54": "35 mm",
    "tb_txt55": "FOV",
    "tb_txt56": "N/A",
    "tb_txt57": "HFOV 12.5°, VFOV 10°, DFOV 16°",
    "tb_txt58": "HFOV 12.5°, VFOV 10°, DFOV 16°",
    "tb_txt59": "Laser rangefinder",
    "tb_txt60": "Wavelength",
    "tb_txt61": "N/A",
    "tb_txt62": "N/A",
    "tb_txt63": "900 - 908 nm (eye - safe)",
    "tb_txt64": "Measurement range",
    "tb_txt65": "N/A",
    "tb_txt66": "N/A",
    "tb_txt67": "3.5 - 1000 m",
    "tb_txt68": "Measurement accuracy",
    "tb_txt69": "N/A",
    "tb_txt70": "N/A",
    "tb_txt71": "1 m",
    "tb_txt72": "Interface",
    "tb_txt73": "Video output: SDI - OUT; Pod control: CAN, S - BUS, R232; Tracking module: SDI - N, AV - N, HDMI - OUT, SDI - OUT, USB",
    "tb_txt74": "Environmental adaptability",
    "tb_txt75": "Operating temperature: - 20°C to 55°C; Storage temperature: - 20°C to 60°C",
    "tb_txt76": "For more information about HW - Gimbal series electro - optical pods, please contact us"

  },
  'avionics_gimbalSpecial': {
    'text1': 'HW-Gimbal Specialized Optical Pods',
    'text2': 'Specialized in providing complete solutions for all types of high-level UVAs',
    'text3': 'HW-Gimbal special optoelectronic pod adopts multi-frame three-axis mechanical stabilization structure, integrates advanced drive control algorithms to provide the ultimate stability guarantee for the performance of professional loads, expands the on-board AI artificial intelligence module and HW-Link multifunctional data chain, supports a variety of professional control modes, such as portable PAD control terminals, dual-screen ground station, etc., and is capable of realizing the functions of target automatic identification, locking, tracking, aiming, etc., and supports the customization of the development of special professional applications to meet the needs of the special professional application scenarios.',
    'text4': 'Product parameters',
    'text5': 'view',
    'text6': 'close',

    'text7': 'HW-Gimbal Special mechanical stabilized optoelectronic pod',
    'text8': 'Mr Kong：13240113344）',
    'text9': 'Email：public@aeronitor.com',


    "tb_txt1": "HW - Gimbal Special Multi - frame Three - axis Mechanical Stabilized Pod",
    "tb_txt2": "Product model",
    "tb_txt3": "S30F - 30X35IDL30",
    "tb_txt4": "S20T - 30X275CD",
    "tb_txt5": "S30T - 30X75LA0",
    "tb_txt6": "Dimensions | Weight",
    "tb_txt7": "Diameter: 200 mm, Height: 290 mm, Weight: 2.4 kg",
    "tb_txt8": "Diameter: 200 mm, Height: 290 mm, Weight: 4.0 kg",
    "tb_txt9": "Diameter: 200 mm, Height: 292 mm, Weight: ≤ 6.0 kg",
    "tb_txt10": "Voltage | Power consumption",
    "tb_txt11": "18 - 28 V, Normal ≤ 40 W, Peak ≤ 150 W",
    "tb_txt12": "18 - 28 V, Normal ≤ 40 W, Peak ≤ 150 W",
    "tb_txt13": "18 - 28 V, Normal ≤ 40 W, Peak ≤ 150 W",
    "tb_txt14": "Stabilization type",
    "tb_txt15": "Multi - frame three - axis mechanical stabilization",
    "tb_txt16": "Multi - frame three - axis mechanical stabilization",
    "tb_txt17": "Multi - frame three - axis mechanical stabilization",
    "tb_txt18": "Pitch | Heading | Roll",
    "tb_txt19": "+35° to - 125° | 360° x n | +60° to - 60°",
    "tb_txt20": "+45° to - 135° | 360° x n | +50° to - 50°",
    "tb_txt21": "+45° to - 135° | 360° x n | +60° to - 60°",
    "tb_txt22": "Stabilization accuracy",
    "tb_txt23": "≤ 0.1 mrad",
    "tb_txt24": "≤ 0.1 mrad",
    "tb_txt25": "≤ 0.1 mrad",
    "tb_txt26": "Visible light",
    "tb_txt27": "Lens",
    "tb_txt28": "30x optical zoom; Focal length: 4.3 - 129 mm; F1.6 - 4.7",
    "tb_txt29": "30x optical zoom; Focal length: 4.3 - 129 mm; F1.6 - 4.7",
    "tb_txt30": "30x optical zoom; Focal length: 4.3 - 129 mm; F1.6 - 4.7",
    "tb_txt31": "Image",
    "tb_txt32": "FHD, 1080P @ 30 fps",
    "tb_txt33": "FHD, 1080P @ 30 fps",
    "tb_txt34": "FHD, 1080P @ 30 fps",
    "tb_txt35": "FOV",
    "tb_txt36": "63.7° (wide - angle end) to 2.3° (telephoto end)",
    "tb_txt37": "63.7° (wide - angle end) to 2.3° (telephoto end)",
    "tb_txt38": "63.7° (wide - angle end) to 2.3° (telephoto end)",
    "tb_txt39": "Thermal infrared",
    "tb_txt40": "Resolution",
    "tb_txt41": "640 x 512, 12μm pixel",
    "tb_txt42": "640 x 512, 15μm pixel",
    "tb_txt43": "640 x 512, 17μm pixel",
    "tb_txt44": "Type",
    "tb_txt45": "Uncooled vanadium oxide focal plane array, 8 - 14μm",
    "tb_txt46": "Stirling cooler, Wavelength range: 3.7 - 4.8μm",
    "tb_txt47": "Uncooled vanadium oxide focal plane array, 8 - 14μm",
    "tb_txt48": "Focal length",
    "tb_txt49": "35 mm, F1.0",
    "tb_txt50": "20 mm - 275 mm, F5.5",
    "tb_txt51": "75 mm",
    "tb_txt52": "Laser rangefinder",
    "tb_txt53": "Wavelength",
    "tb_txt54": "1530 - 1540 nm",
    "tb_txt55": "N/A",
    "tb_txt56": "1.535μm ± 0.015μm",
    "tb_txt57": "Measurement range",
    "tb_txt58": "50 - 3000 m",
    "tb_txt59": "N/A",
    "tb_txt60": "50 - 10000 m (customizable)",
    "tb_txt61": "Measurement accuracy",
    "tb_txt62": "2 m",
    "tb_txt63": "N/A",
    "tb_txt64": "± 2 m",
    "tb_txt65": "AI module",
    "tb_txt66": "Target detection",
    "tb_txt67": "External",
    "tb_txt68": "External",
    "tb_txt69": "48x48 - 384x384 (pix x pix); ≤ 20 ms",
    "tb_txt70": "Functions",
    "tb_txt71": "Picture - in - picture, OSD (can overlay characters, aiming lines, angles and other information), Support for encoded video output, etc., 64G memory (18 - hour internal recording), AI automatic target recognition, locking, tracking, AR overlay, etc.",
    "tb_txt72": "Interface",
    "tb_txt73": "Pod control",
    "tb_txt74": "CAN, S - BUS, RS232, TTL, Asynchronous 422",
    "tb_txt75": "Video output",
    "tb_txt76": "Ethernet port, Synchronous 422, HDMI - OUT",
    "tb_txt77": "Environmental adaptability",
    "tb_txt78": "Operating temperature: - 20°C to 55°C; Storage temperature: - 40°C to 60°C",

    'productParameter': [
      {
        "title": "HW - Gimbal S20 - 95 - 1 Two - axis Dual - optical Automatic Observation and Aiming Pod",
        "desc": "It is equipped with a visible - light camera with 30x optical zoom and a 1 - km laser rangefinder, and is hung under the 95 - 1. It has the ability to stabilize pitch and heading, with a stabilization accuracy of up to 0.5 mrad. The three payloads are optically coaxial, enabling automatic aiming, tracking and precise strikes.",
        "params": [
          {
            "label": "Dimensions | Weight",
            "value": "Height: 460 mm, Length: 753 mm, Width: 261 mm, Weight: 10.5 kg"
          },
          {
            "label": "Voltage | Power consumption",
            "value": "18 - 28 V, Normal ≤ 25 W, Peak ≤ 150 W"
          },
          {
            "label": "Stabilization performance",
            "value": "Two - axis mechanical stabilization, Stabilization accuracy ≤ 0.1 mrad"
          },
          {
            "label": "Pitch | Heading",
            "value": "+10° to - 35° | +45° to - 45°"
          },
          {
            "label": "Visible light",
            "value": "30x optical zoom, 1080P @ 30 fps, FOV: 63.7° (wide - angle end) to 2.3° (telephoto end)"
          },
          {
            "label": "Laser rangefinder",
            "value": "Wavelength: 900 - 908 nm, Measuring range: 3.5 - 800 m, Accuracy: 1 m"
          },
          {
            "label": "Tracking module",
            "value": "Tracked target size: 48x48 - 384x384 (pix x pix), Response time < 50 ms"
          },
          {
            "label": "Strike accuracy",
            "value": "For a 25 - m dynamic target, better than ± 5 cm; for a 50 - m dynamic target, better than ± 10 cm"
          },
          {
            "label": "Environmental adaptability",
            "value": "Operating temperature: - 20°C to 55°C; Storage temperature: - 40°C to 60°C"
          }
        ]
      },
      {
        "title": "HW - Gimbal S30T - 30X35LD20 Three - axis Triple - optical Illumination Pod",
        "desc": "It integrates a visible - light camera with 30x optical zoom, an infrared module and a laser illumination module. It can be expanded with an AI intelligent module to automatically identify, lock and track moving targets. It is capable of all - day reconnaissance and laser illumination tasks, guiding precise strikes.",
        "params": [
          {
            "label": "Dimensions | Weight",
            "value": "Diameter ≤ 172 mm, Height ≤ 265 mm, Weight ≤ 2.5 kg"
          },
          {
            "label": "Voltage | Power consumption",
            "value": "18 - 28 V, Normal ≤ 25 W, Peak ≤ 250 W (when the illuminator is working)"
          },
          {
            "label": "Stabilization performance",
            "value": "Multi - frame three - axis mechanical stabilization, Stabilization accuracy ≤ 0.1 mrad"
          },
          {
            "label": "Pitch | Heading | Roll",
            "value": "+45° to - 135° | 360° x n | +40° to - 40°"
          },
          {
            "label": "Visible light",
            "value": "30x optical zoom, 1080P @ 30 fps, FOV: 63.7° (wide - angle end) to 2.3° (telephoto end)"
          },
          {
            "label": "Infrared",
            "value": "640 x 512, Uncooled vanadium oxide focal plane array, 8 - 14μm, Fixed - focus lens with 35 mm focal length"
          },
          {
            "label": "Laser illumination",
            "value": "Wavelength: 1.064μm, Pulse energy ≥ 25 mJ, Illumination distance ≥ 2 km, Ranging accuracy: ± 1 m"
          },
          {
            "label": "Tracking module",
            "value": "Tracked target size: 48x48 - 384x384 (pix x pix), Response time < 50 ms"
          },
          {
            "label": "Environmental adaptability",
            "value": "Operating temperature: - 20°C to 55°C; Storage temperature: - 40°C to 60°C"
          }
        ]
      },
      {
        "title": "HW - Gimbal S10T - SP300 Professional Multi - frame Three - axis Stabilized Mapping Pod",
        "desc": "Combining a high - precision three - axis mechanical stabilized pod platform with a Phase One professional aerial mapping camera, it enables high - resolution image acquisition while maintaining angles. It supports real - time transmission of image data and is suitable for long - distance aerial mapping tasks with high surface resolution.",
        "params": [
          {
            "label": "Dimensions | Weight",
            "value": "Diameter: 300 mm, Height: 435 mm, Weight: 9.1 kg"
          },
          {
            "label": "Voltage | Power consumption",
            "value": "18 - 28 V, Normal ≤ 25 W, Peak ≤ 200 W"
          },
          {
            "label": "Stabilization performance",
            "value": "Multi - frame three - axis mechanical stabilization, Stabilization accuracy: 0.2 mrad"
          },
          {
            "label": "Pitch | Heading | Roll",
            "value": "+25° to - 135° | 360° x n | +30° to - 30°"
          },
          {
            "label": "Mapping camera",
            "value": "Phase One professional aerial mapping camera"
          },
          {
            "label": "Sensor",
            "value": "Back - illuminated CMOS, Pixel: 11664 x 8750, Pixel pitch: 3.76μm"
          },
          {
            "label": "Lens",
            "value": "300 mm fixed - focus lens"
          },
          {
            "label": "Surface resolution",
            "value": "1.253 cm @ 1000 m, 2.506 cm @ 2000 m, 3.759 cm @ 3000 m"
          },
          {
            "label": "Environmental adaptability",
            "value": "Operating temperature: - 20°C to 55°C; Storage temperature: - 40°C to 60°C"
          }
        ]
      }
    ]

  },
  'avionics_link': {
    'text1': 'HW-Link Graphic, digital, and audio all-in-one datalink featured benefits',
    'text2': 'Focusing on providing complete solutions for various types of advanced unmanned aerial vehicles',
    'text3': 'The HW-Link series multifunctional data link integrates high-definition image transmission link, CNC link, differential correction link, and multiple channels to provide stable, low latency, long-distance high-definition imaging and data communication support for various drones. The HW-Link series products are divided into multiple versions such as 30km, 50km, 100km, and 200km.',
    'text4': 'The HW-Link series data link products support a "machine machine" relay mode, which can achieve high-definition imaging and data communication up to over 300km; Capable of ensuring communication between 1V4 and 1V1 cluster drones; It can be paired with a ground turntable relay system to achieve stable communication over longer distances, and is widely used in scenarios such as long-distance transmission line inspection, oil and gas pipeline patrol, maritime cruise, border patrol, forest fire protection, military investigation, etc.',
    'text5': 'Features and advantages of HW-Link digital audio integrated data link',
    'text6': 'Product parameters',
    'text7': 'view',
    'text8': 'close',
    'applicationTitle': "Applicable to multiple unmanned vehicles",
    'tel': "Mr Kong：13240113344",
    'email': "Email：public@aeronitor.com",
    'applyData': [
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "Graphic, digital and audio all-in-one, multiplexed",
        'desc': "Incorporating HD mapping link (supporting HD video, picture, sound, etc.), CNC link, and differential correction link, it is a multi-channel all-in-one, easy to deploy, and has comprehensive functions.",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "Graphic, digital and audio all-in-one, multiplexed"
      },
      {
        'type': '0',
        'title': "Supports “UAV-to-UAV” trunking, widely applicable",
        'desc': "Supports “UAV-to-UAV” trunking。Stable connectivity is guaranteed even in mountainous areas where communications are blocked, and at sea where microwave reflections and absorptions occur.",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "Supports “UAV-to-UAV” trunking, widely applicable"
      },
      {
        'type': '0',
        'title': "Supports base station roaming and full area coverage",
        'desc': "Support base station roaming function, through the distributed deployment of multiple roaming base stations, can realize city-level blind-zone-free full-area communication coverage",
        'img': "/static/images/avionics/common/application3.jpg",
        'alt': "Supports base station roaming and full area coverage"
      },
      {
        'type': '0',
        'title': "Expanded directional turntable, longer communication radius",
        'desc': "Expandable ground repeater relay system to automatically track the real-time position of the UAV and realize a longer communication radius.",
        'img': "/static/images/avionics/common/application4.jpg",
        'alt': "Expanded directional turntable, longer communication radius"
      },
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "Support pod control, simple and convenient",
        'desc': "Supporting portable PAD pod control and PC upper computer pod remote control, providing a variety of load control interfaces, load control is more simple and convenient.",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "Support pod control, simple and convenient"
      },
      {
        'type': '0',
        'title': "Support cluster communication and efficient collaboration",
        'desc': "HW-Link cluster data chain supports various cluster UAV communication modes such as 1V4, 1V16, etc., which comprehensively guarantees efficient UAV cluster coordination.",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "Support cluster communication and efficient collaboration"
      }
    ],
    'application': [
      {
        'label': "HW-Link 1V4 clustered datalink",
        'img': "/static/images/avionics/common/1.jpg"
      },
      {
        'label': "HW-Link 30km, 50km data",
        'img': "/static/images/avionics/common/1.jpg"
      },
      {
        'label': "HW-Link 100km data link",
        'img': "/static/images/avionics/common/2.png"
      },
      {
        'label': "HW-Link 200km data link",
        'img': "/static/images/avionics/common/3.png"
      },
      {
        'label': "Small ground repeater trunking data link",
        'img': "/static/images/avionics/common/4.png"
      },
      {
        'label': "Airborne tracking data link",
        'img': "/static/images/avionics/common/5.png"
      },
      {
        'label': "Large ground repeater trunking data link",
        'img': "/static/images/avionics/common/1.jpg"
      }
    ],
    'productParameter': [

      {
        'title': ['HW-Link100'],
        'columnSpan': 4,
        'data': [
          {
            "label": "Operating frequency band",
            "value": "1430 - 1444 MHz",
            "label2": "Transmission power",
            "value2": "ANT1: 41 ± 1 dBm; ANT2: 23 ± 1 dBm"
          },
          {
            "label": "Receiving sensitivity",
            "value": "ANT1: ≤ -89 dBm; ANT2: ≤ -90 dBm",
            "label2": "Maximum communication distance",
            "value2": "7 Mbps @ 100 km (Omnidirectional antenna, 1080P @ 30 fps)"
          },
          {
            "label": "Diversity mode",
            "value": "Asymmetric 2x2 MINO, transmit diversity + receive diversity",
            "label2": "Supported media types",
            "value2": "1080P high - definition video, pictures, sound, etc."
          },
          {
            "label": "Supported data transmission function",
            "value": "115200 bps, RS232",
            "label2": "Supported RTK calibration",
            "value2": "115200 bps, RS232"
          }
        ]
      },
      {
        "title": ["Ground terminal", "Airborne terminal"],
        "columnSpan": 2,
        "data": [
          {
            "label": "Dimensions",
            "value": "130 mm x 100 mm x 66 mm",
            "label2": "Dimensions",
            "value2": "130 mm x 63 mm x 66 mm"
          },
          {
            "label": "Weight",
            "value": "606 g (excluding antenna)",
            "label2": "Weight",
            "value2": "554 g (excluding antenna)"
          },
          {
            "label": "Antenna length",
            "value": "120 cm",
            "label2": "Antenna length",
            "value2": "138 mm"
          },
          {
            "label": "Antenna weight",
            "value": "400 g x 2",
            "label2": "Antenna weight",
            "value2": "14.2 g x 2"
          },
          {
            "label": "Antenna gain",
            "value": "6 dBi",
            "label2": "Antenna gain",
            "value2": "2 dBi"
          },
          {
            "label": "Operating voltage",
            "value": "24 V ± 10% (6S lithium - ion battery)",
            "label2": "Operating voltage",
            "value2": "24 V ± 10% (6S lithium - ion battery)"
          },
          {
            "label": "Operating power consumption",
            "value": "≤ 20 W",
            "label2": "Operating power consumption",
            "value2": "≤ 50 W"
          },
          {
            "label": "Operating environment temperature",
            "value": "-10°C to 60°C",
            "label2": "Operating environment temperature",
            "value2": "-10°C to 60°C"
          },
          {
            "label": "Supported video output",
            "value": "HDMI 1080P @ 60 fps",
            "label2": "Supported video output",
            "value2": "SDI 1080P @ 30 fps"
          },
          {
            "label": "Supported Ethernet",
            "value": "100 Mbps",
            "label2": "Supported Ethernet",
            "value2": "100 Mbps (customized)"
          },
          {
            "label": "Data link interface",
            "value": "RS232 x 3",
            "label2": "Data link interface",
            "value2": "RS232 x 3"
          }
        ]
      }

    ]
  },
  'avionics_pilot': {
    'text1': 'HW-Pilot UAV flight control system',
    'text2': 'Focusing on providing complete solutions for various types of advanced unmanned aerial vehicles',
    'text3': 'Adopting a three redundant safety redundancy hardware architecture, integrating RTK high-precision positioning modules, supporting various types of composite wing, fixed wing, medium to large multi rotor, variable pitch multi rotor, single rotor helicopter, coaxial helicopter, tandem helicopter, cruise missile and other aircraft models',
    'text4': 'We can provide complete solutions and complete machine installation services for high-order unmanned aerial vehicle systems, including a multifunctional data link with integrated digital graphics, a multi frame three-axis mechanical stabilized optoelectronic pod, and an onboard AI. We also support extended applications such as semi physical simulation training systems and a fully functional backend live streaming management system, which only require personalized matching',
    'text5': 'HW-Pilot Characteristics and advantages of unmanned aerial vehicle flight control system',
    'text6': 'Product parameters',
    'text7': 'view',
    'text8': 'close',
    'applicationTitle': "Applicable to multiple unmanned vehicles",
    'tel': "Mr Kong：13240113344",
    'email': "Email：public@aeronitor.com",
    'application': [
      {
        'label': "Small, medium and large composite wing UAVs",
        'img': "/static/images/avionics/common/1.jpg"
      },
      {
        'label': "Medium and large multi-rotor UAVs",
        'img': "/static/images/avionics/common/2.png"
      },
      {
        'label': "Variable Pitch Multi-Rotor UAV",
        'img': "/static/images/avionics/common/3.png"
      },
      {
        'label': "Single-rotor, co-axial unmanned helicopter",
        'img': "/static/images/avionics/common/4.png"
      },
      {
        'label': "Vertical twin-rotor unmanned helicopter",
        'img': "/static/images/avionics/common/5.png"
      },
      {
        'label': "patrol missile",
        'img': "/static/images/avionics/common/1.jpg"
      }
    ],
    'applyData': [
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "Parameter identification modeling + modern robust control",
        'desc': "Adoption of body parameter identification modeling + modern robust control to ensure system robustness and excellent control performance",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "Parameter identification modeling + modern robust control"
      },
      {
        'type': '0',
        'title': "GNSS satellites work under denial conditions",
        'desc': "Unique satellite-independent navigation algorithms for continuous target locking and tracking in satellite denial conditions via optronic pods",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "GNSS satellites work under denial conditions"
      },
      {
        'type': '0',
        'title': "High reliability, support for large drones",
        'desc': "Three degrees of hardware safety redundancy design, expanding the Kalman filter algorithm, through more than 150,000 flight tests, support for large-scale UAV platforms and multiple types of aircraft models",
        'img': "/static/images/avionics/common/application3.jpg",
        'alt': "High reliability, support for large drones"
      },
      {
        'type': '0',
        'title': "Expandable LiDAR mapping, obstacle avoidance, odometry",
        'desc': "Radar inertial odometry LIO + visual inertial odometry VIO for stability and safety in scenarios such as firefighting hovering between high-rise buildings",
        'img': "/static/images/avionics/common/application4.jpg",
        'alt': "Expandable LiDAR mapping, obstacle avoidance, odometry"
      },
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "Shipboard, vehicle and other moving platforms take-off and landing",
        'desc': "Expandable mobile platform function module, support shipboard, vehicle-mounted and other mobile platforms to take off and land while traveling, widely used in sea, maneuvering takeoff and landing scenarios",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "Shipboard, vehicle and other moving platforms take-off and landing"
      },
      {
        'type': '0',
        'title': "Supports a wide range of specialized aero-engines",
        'desc': "Compatible control of Zongshen C145H, hangrui DB416, ROTAX915 and other professional aviation engines",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "Supports a wide range of specialized aero-engines"
      },
      {
        'type': '0',
        'title': "Semi-physical simulation training system, live backstage management system",
        'desc': "Expandable semi-physical simulation training system, reduce training costs and risks, support the backstage live management, at any time and any place to grasp the live situation",
        'img': "/static/images/avionics/common/application3.jpg",
        'alt': "Semi-physical simulation training system, live backstage management system"
      },
      {
        'type': '0',
        'title': "Complete solutions, complete installation services",
        'desc': "Provide complete solutions for advanced unmanned aerial systems including integrated multi-functional datalinks, multi-frame three-axis mechanically stabilized optoelectronic pods, airborne AI, etc., and complete aircraft installation services.",
        'img': "/static/images/avionics/common/application4.jpg",
        'alt': "Complete solutions, complete installation services"
      }],
    'productParameter': [
      {
        "label": "Gyroscope range",
        "value": "±2000 dps",
        "label2": "Accelerometer range",
        "value2": "±16 g"
      },
      {
        "label": "Altitude resolution",
        "value": "0.1 m",
        "label2": "Static pressure sensor",
        "value2": "120 kPa"
      },
      {
        "label": "Cylinder temperature acquisition",
        "value": "Supported",
        "label2": "Dynamic pressure sensor",
        "value2": "137.9 kPa, supports 1707 km/h"
      },
      {
        "label": "Rotational speed acquisition",
        "value": "Supported",
        "label2": "CAN bus",
        "value2": "3-channel CAN communication, supports smart battery"
      },
      {
        "label": "Fuel level acquisition",
        "value": "Supported",
        "label2": "S-BUS bus",
        "value2": "1-channel SBUS, can connect to SBUS receiver"
      },
      {
        "label": "Aerial photography POS data",
        "value": "10K",
        "label2": "PWM channel",
        "value2": "12-channel output"
      },
      {
        "label": "Data storage",
        "value": "8G",
        "label2": "Serial port",
        "value2": "6 channels"
      },
      {
        "label": "GPS positioning accuracy",
        "value": "2.5 m",
        "label2": "GPS update frequency",
        "value2": "10 Hz"
      },
      {
        "label": "Main functions of RTK",
        "value": "RTK, PPK, dual-antenna direction finding",
        "label2": "RTK positioning accuracy",
        "value2": "Horizontal: 1 cm + 1 ppm, Vertical: 2 cm + 1 ppm"
      },
      {
        "label": "RTK orientation accuracy",
        "value": "0.2/D° (D is the distance between sky-end antennas, unit: m)",
        "label2": "RTK operating frequency points",
        "value2": "GPS: L1, L2; GLONASS: G1, G2; BD: B1, B2 (B3 optional)"
      },
      {
        "label": "RTK speed measurement accuracy (RMS)",
        "value": "0.02 m/s",
        "label2": "PPK",
        "value2": "Frequency: 2 Hz, 5 Hz, 10 Hz; Storage space: 8 GB; Data reading interface: USB 2.0"
      },
      {
        "label": "Supply voltage",
        "value": "6 - 26 V",
        "label2": "Power consumption",
        "value2": "< 6 W"
      },
      {
        "label": "Operating temperature",
        "value": "-20°C - 60°C",
        "label2": "Storage temperature",
        "value2": "-40°C - 80°C"
      },
      {
        "label": "Flight control module weight",
        "value": "217 g",
        "label2": "Flight control module dimensions",
        "value2": "112 mm x 100 mm x 35 mm"
      },
      {
        "label": "GPS module weight",
        "value": "41 g",
        "label2": "GPS module dimensions",
        "value2": "55 mm (diameter) x 13 mm"
      },
      {
        "label": "Software voice",
        "value": "Chinese",
        "label2": "Operating system",
        "value2": "Microsoft Windows 7/8/10, 32/64 bits"
      }
    ]
  },
  'avionics_pod': {
    'text1': 'Pod',
    'text2': 'three gyroplatform',
    'text3': '1080P high-definition image transmission with 30x optical zoom and anti wind resistance spherical design',
    'text4': 'High precision target recognition and tracking',
    'text5': 'Equipped with a high-definition visible light camera and precise infrared camera, integrated with CNN intelligent visual tracking algorithm, it can overcome temporary occlusion and other visual artifacts, and stably track targets',
    'text6': 'High definition imaging, as if in person',
    'text7': 'The equipped visible light camera has 30x optical zoom capability, high-definition imaging, and breaks through visual constraints.',
    'text8': 'High definition imaging, as if in person',
    'text9': 'The equipped visible light camera has 30x optical zoom capability, high-definition imaging, and breaks through visual constraints.',
    'text10': 'Solution Customization Expert',
    'text11': 'view',
    'text12': 'close',
    'text13': 'sales hotline：010-58650999',
    'text14': 'Email：public@aeronitor.com',
  },
  'avionics_polaris': {
    'text1': 'Polaris three redundancy autopilot',
    'text2': 'The all-new Polaris three redundancy autopilot adopts a three redundancy safety design',
    'text3': 'Select high-performance sensors for stability and reliability',
    'text4': 'Optimize algorithms to ensure flight safety',
    'text5': 'Adopting a triple redundant safety design, three sets of algorithms operate independently, and data is backed up with each other. In case of a fault, the system can be switched smoothly to ensure flight safety. The innovative fusion of L1 nonlinear navigation algorithm and B747 level total energy control algorithm enhances the drone"s ability to cope with turbulence and wind shear, making flight missions more secure.',
    'text6': 'Exquisite material selection and ingenious design',
    'text7': 'Preferred industrial grade IMU with high precision, stability, and reliability, fearless of harsh environments. The product adopts modular design and aviation grade plugs to solve the problem of disorderly wiring inside the cabin.',
    'text8': 'Comprehensive protection, safe and reliable',
    'text9': 'The self inspection system can conduct a comprehensive and rapid inspection of unmanned aerial vehicles before takeoff. If an abnormality is found, the system refuses to unlock and takes preventive measures; At the same time, it has a complete emergency protection mechanism that supports preset forced landing waypoints. In case of emergency, it can hover in place or make an autonomous forced landing.',
    'text10': 'Powerful data support',
    'text11': 'The black box data recording system integrates a 4GB data storage capacity SD card and can provide real-time recording of flight data for over 50 hours.',
    'text12': 'Intelligent visual positioning module (optional module)',
    'text13': 'The integrated binocular depth map and Visual Inertial Odometer system can achieve autonomous takeoff, landing, and obstacle avoidance in valleys, buildings, and other situations without GPS signals, reducing the requirements for the working environment and having a wider range of applications.',
    'text14': 'Ground station software',
    'text15': 'The supporting ground station software can achieve powerful functions such as online parameter adjustment and flight mission planning for Polaris autopilot, with a user-friendly interface, convenient operation, and high usability.',
    'text16': 'function characteristics',
    'text17': 'Solution Customization Expert',
    'text18': 'view',
    'text19': 'close',
    'text20': 'sales hotline：010-58650999',
    'text21': 'Email：public@aeronitor.com',
    'characteristicsData': [
      {
        'title': "Suitable for various models",
        'desc': "V-tail, flying wing, tandem, etc"
      },
      {
        'title': "Supports multiple takeoff and landing modes",
        'desc': "Vertical takeoff and landing, taxiing takeoff and landing, ejection, vehicle takeoff and parachute landing"
      },
      {
        'title': "Supports multiple flight control modes",
        'desc': "Manual, semi-automatic, fully autonomous flight"
      },
      {
        'title': "Supports multiple connection methods",
        'desc': "Recognized physical connections, plug and play, and strong scalability"
      },
      {
        'title': "Support speed",
        'desc': "Collect cylinder temperature, oil volume, and multi-channel voltage, and reserve multiple backup ADs"
      },
      {
        'title': "Supports RTK",
        'desc': "Real time dynamic differential technology with positioning accuracy up to centimeter level"
      },
      {
        'title': "Support PPK",
        'desc': "Post event differential global positioning system"
      },
      {
        'title': "Can be equipped with photoelectric pods, equidistant, fixed-point exposure cameras",
        'desc': "Supports photo control and automatic POS data storage"
      }
    ],
  },
  //-------------
  'index_index': {

  },
  //-------------
  'industry_hw600': {
    'text1': 'net weight：200kg',
    'text2': 'Longer ENDURANCE',
    'text3': 'Longitudinal layout structure，High load capacity',
    'text4': 'Endurance：1——8h，flight speed：150km/h',
    'text5': 'net payload：200kg，endurance：1h',
    'text6': 'net payload：150kg， endurance：3.5h',
    'text7': 'Anti-Satellite Navigation Interference',
    'text8': 'Supports visual inertial guidance fusion navigation flight mode in non-satellite navigation mode。When satellite navigation signals are interfered with or disturbed, the drone can still carry out its mission normally or land and return accurately by visual fusion navigation.，stable and reliable all the way through, safe to work with.',
    'text9': 'Large loading space, large center of gravity range, suitable for hanging',
    'text10': 'The whole aircraft rotor adopts one front and one rear layout, with a wide range of center of gravity.',
    'text11': 'Large loading space, support hanging all kinds of large equipment',
    'text12': 'LIDAR Omnidirectional Obstacle Avoidance',
    'text13': 'Autonomous sensing and obstacle avoidance recognition capability，unaffected by ambient light, smoke, etc. It supports automatic obstacle avoidance and imitation ground flight function, which guarantees the safety and stability of UAV flight in all-weather and complex environments.',
    'applicationTitle': "Wide range of application scenarios",
    'application': [
      {
        'label': "Emergency security material delivery",
        'img': "/static/images/industry/hw600/application1.png"
      },
      {
        'label': "Transportation of power maintenance supplies",
        'img': "/static/images/industry/hw600/application2.png"
      },
      {
        'label': "Emergency communications signal security",
        'img': "/static/images/industry/hw600/application3.png"
      },
      {
        'label': "UAV cluster firefighting",
        'img': "/static/images/industry/hw600/application4.png"
      }
    ]
  },
   //--------------
   'industry_hw16v': {
    'text1':'Electric ,Vertical Takeoff and Landing Compound Wing Unmanned Aerial Vehicle',
    'text2':'Avionics > Industrial machines > HW-16V',
    'text3':'HW-16V performance advantages',
    'text4':'Employing a triple-axis safety flight control, dual-antenna differential orientation, onboard AI computing power, it possesses numerous advantages such as long endurance, all-scenario capability, modularity, vertical takeoff and landing. It is highly suitable for remote real-time video inspection scenarios',
    'text5':'Multiple task scenarios for use',
    'text6':'Police, surveying, petroleum, electricity, emergency, environmental protection, maritime, forestry and grass',
    'param':{
      'text0':'Product parameters',
      'text1':'Power by',
      'text1_1':'lithium battery',
      'text2':'Endurance',
      'text3':'Cruise speed',
      'text4':'Maximum load',
      'text5':'Maximum takeoff weight',
      'text6':'Wind resistance level',
      'text7':'Wing span * Fuselage * Height',
      'text8':'Maximum flight altitude',
      'text9':'Transportation case size (m)',
    },
    'advantages': [
      {
        'title': "Pure electric, long endurance",
        'childen':[
          'Pure electric vertical drive for a longer effective operational time with extended takeoff',
        ]
      },
      {
        'title': "VTOL",
        'childen':[
          'Vertical takeoff and landing, modular payload design, a variety of mission payloads to choose from, suitable for multiple mission scenarios',
        ]
      },
      {
        'title': "Onboard AI、AR",
        'childen':[
          'Automatic target recognition, locking, tracking. Real-time overlay presentation of AR data',
        ]
      },
      {
        'title': "Supports 'aircraft-to-aircraft relay",
        'childen':[
          'Innovative dual-aircraft relay technology solves the challenge of long-distance real-time communication in complex terrains such as mountainous areas.',
        ]
      },
      {
        'title': "Countermeasure resistance, anti-jamming",
        'childen':[
          'Proprietary sensor + closed-loop attitude algorithm ensures stable flight in satellite-denied, GPS-interference, and deceptive environments.',
        ]
      },
      {
        'title': "Dynamic Platform Takeoff and Landing",
        'childen':[
          'Equipped with anti-interference sensors, capable of takeoff and landing in non-stationary conditions, such as high-speed movement or complex sea conditions',
        ]
      },
    ],
  },
  'industry_hw25v': {
    'text1':'Electric ,Vertical Takeoff and Landing Compound Wing Unmanned Aerial Vehicle',
    'text2':'Avionics > Industrial machines > HW-16V',
    'text3':'HW-16V performance advantages',
    'text4':'Employing a triple-axis safety flight control, dual-antenna differential orientation, onboard AI computing power, it possesses numerous advantages such as long endurance, all-scenario capability, modularity, vertical takeoff and landing. It is highly suitable for remote real-time video inspection scenarios',
    'text5':'使用多种任务场景',
    'text6':'Police, surveying, petroleum, electricity, emergency, environmental protection, maritime, forestry and grass',
  },
  'industry_hw60v': {
    'text1':'Vertical takeoff and landing composite wing unmanned aerial vehicle',
    'text2':'Avionics > Industrial machines > HW-60V',
    'text3':'HW-60V performance advantages',
    'text4':'Electric/oil powered long endurance suitable for all scenario',
    'text5':'Multiple task scenarios for use',
    'text6':'Police, surveying, petroleum, electricity, emergency, environmental protection, maritime, forestry and grass',
    'param':{
      'text0':'Product parameters',
      'text1':'Power by',
      'text1_1':'Gasoline/Heavy Oil',
      'text2':'Endurance',
      'text3':'Cruise speed',
      'text4':'Maximum load',
      'text5':'Maximum takeoff weight',
      'text6':'Wind resistance level',
      'text7':'Wing span * Fuselage * Height',
      'text8':'Maximum flight altitude',
      'text9':'Transportation case size (m)',
    },
    'advantages': [
      {
        'title': "Enhanced Performance",
        'childen':[
          'Endurance: 4-8 hours ',
          'Range:50km/100km/300km (Customizable effective operational radius)',
          'Payload Capacity : 15kg Modular Payload System'
        ]
      },
      {
        'title': "All-Weather Flight Capability",
        'childen':[
          'Wind Resistance Level: Cruise wind resistance level 7',
          'Rain Resistance:Light rain: Extended flight duration- Moderate rain: Single flight ≥3 hours- Heavy rain: Single flight ≥1 hour',
        ]
      },
      {
        'title': "Enhanced Safety",
        'childen':[
          'Dual Antenna Differential Orientation Technology',
          'High-Integrated Avionics System',
          'a triple-axis safety flight control'
        ]
      },
      {
        'title': "Technological Innovation",
        'childen':[
          'Anti-Deception/Interference',
          'Proprietary Sensor + Closed-Loop Attitude Algorithm',
          'Ensures Stable Flight in Satellite-denied, GPS-interference, and Deceptive Environments',
        ]
      },
      {
        'title': "Data Link",
        'childen':[
          'Standard configuration includes a 50km (electric) / 100km (gasoline) data link, expandable to 300km. It supports "aircraft-to-aircraft relay" technology',
        ]
      },
      {
        'title': "AI + AR",
        'childen':[
          'AR Data Overlay to prevent getting lost',
          'Real-time density statistics of people, vehicles, animals, etc',
          'Onboard AI for dynamic target identification, locking, and tracking of people, vehicles, etc',
        ]
      },
      {
        'title': "Dynamic Platform Takeoff + Remote Takeoff",
        'childen':[
          'Equipped with built-in anti-interference sensors, the drone can take off and land in non-stable conditions such as high-speed movement or complex sea conditions',
          'It also supports remote takeoff within a 100km range. ',
        ]
      },
      {
        'title': "loudspeaker, LiDAR, Diverse Mission Payloads",
        'childen':[
          'With a payload capacity of up to 15kg, the drone can carry various rich payloads such as loudspeakers, electro-optical gimbals , LiDAR, survey cameras, and more. It is widely applicable across various scenarios',
        ]
      },
    ],
  },
  'industry_hw120v': {
    'text1':'Vertical takeoff and landing composite wing unmanned aerial vehicle',
    'text2':'Avionics > Industrial machines > HW-120V',
    'text3':'HW-120V performance advantages',
    'text4':'Electric/oil powered long endurance suitable for all scenario',
    'text5':'Multiple task scenarios for use',
    'text6':'Police, surveying, petroleum, electricity, emergency, environmental protection, maritime, forestry and grass',
    'param':{
      'text0':'Product parameters',
      'text1':'Power by',
      'text1_1':'Gasoline',
      'text2':'Endurance',
      'text3':'Cruise speed',
      'text4':'Maximum load',
      'text5':'Maximum takeoff weight',
      'text6':'Wind resistance level',
      'text7':'Wing span * Fuselage * Height',
      'text8':'Maximum flight altitude',
      'text9':'Transportation case size (m)',
    },
    'advantages': [
      {
        'title': "Enhanced Performance",
        'childen':[
          'Endurance : 8 hours',
          'Range: 100km/300km+ (Customizable effective operational radius)',
          'Payload Capacity : 40kg- Modular Payload System'
        ]
      },
      {
        'title': "All-Weather Flight Capability",
        'childen':[
          'Wind Resistance Level: Cruise wind resistance level 7',
          'Rain Resistance:Light rain: Extended flight duration - Moderate rain: Single flight ≥3 hours - Heavy rain: Single flight ≥1 hour',
        ]
      },
      {
        'title': "Enhanced Safety",
        'childen':[
          'Dual Antenna Differential Orientation Technology',
          'High-Integrated Avionics System',
          'a triple-axis safety flight control'
        ]
      },
      {
        'title': "Technological Innovation",
        'childen':[
          'Anti-Deception/Interference',
          'Proprietary Sensor + Closed-Loop Attitude Algorithm',
          'Ensures Stable Flight in Satellite-denied, GPS-interference, and Deceptive Environments',
        ]
      },
      {
        'title': "Data Link",
        'childen':[
          'Standard configuration includes a 100km data link, expandable to 300km+. It supports "aircraft-to-aircraft relay" technology',
        ]
      },
      {
        'title': "AI + AR",
        'childen':[
          'AR Data Overlay to prevent getting lost',
          'Real-time density statistics of people, vehicles, animals, etc',
          'Onboard AI for dynamic target identification, locking, and tracking of people, vehicles, etc',
        ]
      },
      {
        'title': "Dynamic Platform Takeoff + Remote Takeoff",
        'childen':[
          'Equipped with built-in anti-interference sensors, the drone can take off and land in non-stable conditions such as high-speed movement or complex sea conditions',
          'It also supports remote takeoff within a 300km range. ',
        ]
      },
      {
        'title': "Loudspeaker, LiDAR, Diverse Mission Payloads",
        'childen':[
          'With a payload capacity of up to 40kg, the drone can carry various rich payloads such as loudspeakers, electro-optical gimbals , LiDAR, survey cameras, satellite communication equipment, base stations, and more. It is widely applicable across various scenarios',
        ]
      },
    ],
  },
  'industry_hw150v': {
    'text1':'Vertical takeoff and landing composite wing unmanned aerial vehicle',
    'text2':'Avionics > Industrial machines > HW-150V',
    'text3':'HW-150V performance advantages',
    'text4':'Electric/oil powered long endurance suitable for all scenario',
    'text5':'Multiple task scenarios for use',
    'text6':'Police, surveying, petroleum, electricity, emergency, environmental protection, maritime, forestry and grass',
    'param':{
      'text0':'Product parameters',
      'text1':'Power by',
      'text1_1':'Gasoline',
      'text2':'Endurance',
      'text3':'Cruise speed',
      'text4':'Maximum load',
      'text5':'Maximum takeoff weight',
      'text6':'Wind resistance level',
      'text7':'Wing span * Fuselage * Height',
      'text8':'Maximum flight altitude',
      'text9':'Transportation case size (m)',
    },
    'advantages': [
      {
        'title': "Enhanced Performance",
        'childen':[
          'Endurance : 10 hours',
          'Range: 100km/300km+ (Customizable effective operational radius)',
          'Payload Capacity : 40kg- Modular Payload System'
        ]
      },
      {
        'title': "All-Weather Flight Capability",
        'childen':[
          'Wind Resistance Level: Cruise wind resistance level 7',
          'Rain Resistance:Light rain: Extended flight duration - Moderate rain: Single flight ≥3 hours - Heavy rain: Single flight ≥1 hour',
        ]
      },
      {
        'title': "Enhanced Safety",
        'childen':[
          'Dual Antenna Differential Orientation Technology',
          'High-Integrated Avionics System',
          'a triple-axis safety flight control'
        ]
      },
      {
        'title': "Technological Innovation",
        'childen':[
          'Anti-Deception/Interference',
          'Proprietary Sensor + Closed-Loop Attitude Algorithm',
          'Ensures Stable Flight in Satellite-denied, GPS-interference, and Deceptive Environments',
        ]
      },
      {
        'title': "Data Link",
        'childen':[
          'Standard configuration includes a 100km data link, expandable to 300km+. It supports "aircraft-to-aircraft relay" technology',
        ]
      },
      {
        'title': "AI + AR",
        'childen':[
          'AR Data Overlay to prevent getting lost',
          'Real-time density statistics of people, vehicles, animals, etc',
          'Onboard AI for dynamic target identification, locking, and tracking of people, vehicles, etc',
        ]
      },
      {
        'title': "Dynamic Platform Takeoff + Remote Takeoff",
        'childen':[
          'Equipped with built-in anti-interference sensors, the drone can take off and land in non-stable conditions such as high-speed movement or complex sea conditions',
          'It also supports remote takeoff within a 300km range. ',
        ]
      },
      {
        'title': "Loudspeaker, LiDAR, Diverse Mission Payloads",
        'childen':[
          'With a payload capacity of up to 40kg, the drone can carry various rich payloads such as loudspeakers, electro-optical gimbals , LiDAR, survey cameras, satellite communication equipment, base stations, and more. It is widely applicable across various scenarios',
        ]
      },
    ],
  },
  'industry_zt25v': {
    'text1': 'Product Introduction',
    'text2': 'Technical Parameter',
    'text3': 'Electric, Vertical Takeoff and Landing Compound Wing Unmanned Aerial Vehicle',
    'text4': 'Pure electric',
    'text5': 'long endurance',
    'text6': 'suitable for all scenarios',
    'text7': 'Strong performance',
    'text8': 'Carrying homework endurance',
    'text9': 'Customizable effective operational radius',
    'text10': 'Modular payload',
    'text11': 'All-weather flight capability',
    'text12': 'Wind resistance level:',
    'text13': 'Cruise wind resistance level 7. ',
    'text14': 'Rain resistance: ',
    'text15': 'Long-duration flight in light rain, single flight ≥3h in moderate rain, and ≥1h in heavy rain.',
    'text16': 'Safer Dual-antenna',
    'text17': 'differential directional technology',
    'text18': 'Highly integrated avionics system',
    'text19': 'Triple-redundancy safety flight control',
    'text20': 'echnological innovation',
    'text21': 'yunxun system',
    'text22': '“yunxun”system functions cover all business processes of human aircraft operation and management, including equipment, personnel, routes, tasks, data, and unlocking. It supports cutting-edge functions such as high-definition live streaming, video distribution, air ground linkage, and two-way interaction',
    'text23': 'Loudspeaker, LiDAR, Diverse Mission Payloads',
    'text24': 'With a payload capacity of up to 10kg, the drone can carry various rich payloads such as loudspeakers, electro-optical gimbals , LiDAR, survey cameras, and more',
    'text25': ' It can also be expanded to support additional mission payloads like multispectral sensors, air quality detectors, and others, making it widely applicable across various scenarios',
    'text26': 'Aircraft',
    listData: [
      {
        title: "Anti-deception/interference",
        desc: "Through proprietary sensors and closed-loop attitude algorithms, navigation can be maintained via heading and payload even in the presence of interference and deception without relying on satellite positioning",
        img: "/static/images/industry/zt25v/section5_plane1.png",
        alt: "抗诱骗/干扰",
        video: []
      },
      {
        title: "The DMS-CAS intelligent anti-collision system ",
        desc: "system  is equipped with a three-dimensional obstacle avoidance pathfinding algorithm based on aircraft dynamic performance and DMS (Digital Surface Model). The drone fully integrates DSM data onboard and can be upgraded to load DSM with precision up to 0.5m in special requirements. The flight control system automatically combines aircraft dynamic characteristics such as wind speed, turn radius, climb rate, maneuverability, and more to dynamically plan mission routes in real-time under various constraint conditions. It can also automatically perform intelligent safety adjustments for \"unsafe\" routes",
        img: "/static/images/industry/zt25v/section5_plane2.png",
        alt: "DSM-CAS 智能防撞系统",
        video: ["https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/fangzhuang_pagao.mp4", "https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/fangzhuang_raoxing.mp4"]
      },
      {
        title: "AR Data Overlay",
        desc: "The drone utilizes AR technology to load target KML (Keyhole Markup Language) . After calibration with DSM data, it can real-time overlay accurate data such as road networks, power line towers, power lines, buildings, and even the distribution of ground forces onto the video screen. This addresses the challenge of \"getting lost\" during drone inspections from a first-person perspective, providing a more intuitive and understandable presentation of inspection results. ",
        img: "/static/images/industry/zt25v/section5_plane3.png",
        alt: "AR数据叠加",
        video: ["https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/AR_shujudiejia.mp4"]
      },
      {
        title: "Video-guided Landing",
        desc: "The drone is equipped with a three-axis gimbal . During landing, the three-axis gimbal automatically points downward for orthogonal projection. Through AI detection and recognition, it can avoid unexpected obstacles like vehicles and personnel. When there is a need to dynamically adjust the target point, one can simply drag the ground landing marker to achieve precise video-guided landing",
        img: "/static/images/industry/zt25v/section5_plane4.png",
        alt: "视频引导降落",
        video: ["https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/yindaojiangluo.mp4"]
      },
      {
        title: "Dynamic Platform Takeoff and Landing",
        desc: "Equipped with built-in anti-interference sensors, the drone can take off and land in non-stable conditions, such as high-speed movement or complex sea conditions",
        img: "/static/images/industry/zt25v/section5_plane5.png",
        alt: "动平台起降",
        video: ["https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/dongpingtaiqijiang.mp4"]
      },
      {
        title: "Airborne Relay",
        desc: "By introducing a relay aircraft in the air, communication relay is achieved. Data is transmitted through the mission aircraft - relay aircraft - ground, unaffected by site and mountain obstructions. This approach can genuinely provide effective coverage in complex environments within the range of 50 to 100 km, ensuring real-time communication and command capabilities in non-line-of-sight environments",
        img: "/static/images/industry/zt25v/section5_plane6.png",
        alt: "空中中继",
        video: []
      }
    ],
    list: [
      {
        title: "Power by",
        desc: "lithium battery"
      },
      {
        title: "Endurance",
        desc: "3.5h"
      },
      {
        title: "Cruise speed",
        desc: "65—120km/h"
      },
      {
        title: "Maximum load",
        desc: "10kg"
      },
      {
        title: "Maximum takeoff weight",
        desc: "36kg"
      },
      {
        title: "Wind resistance level",
        desc: "10m/s"
      },
      {
        title: "Wing span * Fuselage * Height",
        desc: "4.13*1.93*0.76m"
      },
      {
        title: "Maximum flight altitude",
        desc: "6500m"
      },
      {
        title: "Transportation case size (m)",
        desc: "1.56*0.63*0.82"
      }
    ]

  },
  //--------------
  'join_campus': {
    'text1': '概览',
    'text2': '社会招聘',
    'text3': '校园招聘',
    'text4': '校招职位',
    'text5': '简历请发送至： hr@hovwing.com',
    'jobList': [
      {
        'id': "c1",
        'hot': 1,
        'name': "制导与控制算法工程师"
      },
      {
        'id': "c6",
        'hot': 1,
        'name': "无线通信工程师"
      },
      {
        'id': "c7",
        'hot': 0,
        'name': "通信FPGA工程师"
      },

      {
        'id': "c3",
        'hot': 0,
        'name': "视觉算法工程师"
      },
      {
        'id': "c4",
        'hot': 0,
        'name': "AI平台研发工程师"
      },
      {
        'id': "c2",
        'hot': 0,
        'name': "嵌入式软件工程师"
      },
      {
        'id': "c8",
        'hot': 0,
        'name': "硬件工程师"
      },
      {
        'id': "c9",
        'hot': 0,
        'name': "机械结构工程师"
      },
      {
        'id': "c12",
        'hot': 0,
        'name': "地面站软件开发工程师"
      },
      {
        'id': "c11",
        'hot': 0,
        'name': "软件测试工程师"
      },
      {
        'id': "c14",
        'hot': 0,
        'name': "销售工程师"
      },
      {
        'id': "c00",
        'hot': 0,
        'name': "更多职位请电话咨询"
      }
    ]
  },
  'join_detail': {
    'text1': '岗位职责',
    'text2': '任职要求',
    'text3': '简历请发送至：',
    'text4': 'hr@hovwing.com',
    'text5': '投递简历',
    'jobContent': [
      {
        'id': "c1",
        'name': "制导与控制算法工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 对飞行系统建模及辨识；\n2. 智能航行路线的规划与设计；\n3. 设计飞行系统的姿态估计与控制算法；\n4. 多传感器的融合以及对传感器的性能分析与标定",
        'demand': ""
      },
      {
        'id': "c2",
        'name': "嵌入式软件工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 对现有产品的维护与升级；\n2. 完成新产品的嵌入式系统开发；\n3. 新技术、新方案与第三方库的调研与探索",
        'demand': ""
      },
      {
        'id': "c3",
        'name': "视觉算法工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1．图像、视频的目标分类，检测，跟踪；场景识别、分割；人脸检测等算法设计；\n2．跟进和应用相关领域前沿技术。",
        'demand': ""
      },
      {
        'id': "c4",
        'name': "AI平台研发工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1．参与嵌入式机器学习平台整体框架设计和实现；\n2．针对机器学习主流框架功能增强及性能优化；\n3．机器学习算法在不同嵌入式体系结构性能优化。",
        'demand': ""
      },
      {
        'id': "c5",
        'name': "软件工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1.负责PC平台无人机地面站软件的开发与维护；\n2.负责无人机GIS系统的开发与维护；\n3.流媒体的软硬件开发与调试；\n4.持续地优化迭代产品的质量、性能、用户体验。",
        'demand': ""
      },
      {
        'id': "c6",
        'name': "无线通信工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 设计无线通信模块和算法；\n2. 参与无人机无线视频传输设备研发；\n3. 无人机无线视频可靠传输协议设计与研发；\n4. 设计实现无人机视频接口和控制接口相关协议如USB，SDI，MIPI，HDMI，UART，CAN，SBUS。",
        'demand': ""
      },
      {
        'id': "c7",
        'name': "通信FPGA工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1．负责FPGA代码编写、模块设计以及功能仿真；\n2．负责FPGA片内调试，并参与硬件电路调试与测试；\n3．理解产品需求，参与整机产品或系统互联的调试与测试",
        'demand': ""
      },
      {
        'id': "c8",
        'name': "硬件工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 参与新产品设计方案的制定和评审；\n2. 产品相关硬件技术文档的编制；\n3. 负责公司相关产品的硬件部分的设计、开发和后期调试；\n4. 负责公司产品硬件架构设计、芯片选型、原理图设计以及PCB设计和调试；\n5. 硬件技术开发相关的外协工作接口及跟踪，积极配合、协调产品的转产工作，跟踪、分析并解决产品在生产和使用过程中暴露出的问题；\n6. 参与和配合公司其他部门的认证、测试等工作。",
        'demand': ""
      },
      {
        'id': "c9",
        'name': "机械结构工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 快速拆装结构研究&开发；\n2. 机械结构仿真分析及结构强度校验；\n3. 固定翼或多旋翼无人飞行器机械&结构设计；\n4. 无人飞行器自动起降平台开发（机电一体化方向）；\n5. 无人飞行器挂载设备开发（如云台相机、吊舱、探照灯、喊话器等）",
        'demand': ""
      },
      {
        'id': "c10",
        'name': "Web前端开发工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 负责公司信息平台及公司官网的开发与维护;\n2. 根据工作安排，高质、高效地完成代码编写，并且能够进行模块自测，优化、重构等;\n3. 能够与后端开发团队紧密配合，确保代码高效对接;\n4. 能够与各部门同事良好的沟通协作，共同推进工作。",
        'demand': ""
      },
      {
        'id': "c11",
        'name': "软件测试工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 从事无人机及其相关产品的软件功能，兼容性、可靠性、性能等测试工作;\n2. 在需求分析、评审等阶段能够对需求提出合理的优化建议;\n3. 根据需求编写测试用例，制定测试计划，进行bug跟踪及确认，编写测试报告;\n4. 搭建自动化测试平台，设计自动化测试方案，高效完成软件测试工作。",
        'demand': ""
      },
      {
        'id': "c12",
        'name': "地面站软件开发工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1.负责PC平台无人机地面站软件的开发与维护；\n2.负责无人机GIS系统的开发与维护；\n3.流媒体的软硬件开发与调试；\n4.持续地优化迭代产品的质量、性能、用户体验。",
        'demand': ""
      },
      {
        'id': "c13",
        'name': "Java后端开发工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 负责管理平台后端服务的数据库设计，业务代码及接口开发工作；\n2. 负责流媒体服务器相关接口及业务的开发及维护工作；\n3. 协作前端、App和测试，完成产品需求的实现迭代及高质量交付；\n4. 制定及实施产品运维方案，安全策略，并编写项目技术文档；\n5. 新技术预研,协助完成方案选型和设计。",
        'demand': ""
      },
      {
        'id': "c14",
        'name': "销售工程师",
        'area': "北京·海淀",
        'edu': "专科",
        'station': "销售",
        'duty': "1.公司现有客户的维护及新客户的开发；\n2.根据公司市场营销战略，积极完成销售指标；\n3.协调公司内部资源，做好客户公关，与客户保持良好沟通。",
        'demand': ""
      },
      {
        'id': "s1",
        'name': "制导与控制算法工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 负责无人机相关业务应用层功能开发;\n2. 负责多旋翼无人机、垂直起降无人机的导航及控制算法的开发与优化;\n3. 负责无人机与其他模块通信协议的制定及文档编写;\n4. 负责无人机相关载荷及传感器的驱动/应用的开发与调试。",
        'demand': "1. 具备扎实的C/C++语言能力，优秀的软件架构能力和良好的编码风格；\n2. 了解传感器误差模型、掌握GPS/INS组合导航算法；\n3. 掌握飞行动力学、控制相关知识，掌握PID原理及调参手段；\n4. 精通STM32平台开发，熟悉Freertos/Threadx/RT-Thead等嵌入式实时操作系统的使用方法。"
      },
      {
        'id': "s2",
        'name': "Web前端开发工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 负责公司信息平台及公司官网的开发与维护;\n2. 根据工作安排，高质、高效地完成代码编写，并且能够进行模块自测，优化、重构等;\n3. 能够与后端开发团队紧密配合，确保代码高效对接;\n4. 能够与各部门同事良好的沟通协作，共同推进工作。",
        'demand': "1.本科以上学历，两年以上前端开发经验；\n2.熟练使用Html/CSS/JavaScript/Ajax/Jquery 等前端基础技术，能够很好解决浏览器兼容性问题；\n3.至少了解一门前端框架语言（React、Vue、Angular等），了解框架原理，有Vue开发经验者优先；\n4.至少了解过一种前端UI框架（ElementUI、iView、mint-ui等），有实际开发经验者优先；\n5.参与过微信小程序、企业微信、微信公众号等的开发与优化；\n6.能够独立开发简单的前端组件；\n7.具备良好的沟通能力、学习能力、良好的问题分析和解决能力。"
      },
      {
        'id': "s3",
        'name': "Java后端开发工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 负责管理平台后端服务的数据库设计，业务代码及接口开发工作;\n2. 负责流媒体服务器相关接口及业务的开发及维护工作;\n3. 协作前端、App和测试，完成产品需求的实现迭代及高质量交付;\n4. 制定及实施产品运维方案，安全策略，并编写项目技术文档；\n5. 新技术预研,协助完成方案选型和设计。",
        'demand': "1.本科以上学历，计算机等相关专业，2年以上的 JAVA 后端开发经验；\n2.熟练掌握Java程序语言，熟练掌握 Mysql/MongoDB/Redis中一种以上的数据库开发技术；\n3.熟练掌握Spring/SpringMVC/SpringBoot/Mybatis等开发框架，对框架原理有一定的理解；\n4.有良好的数据库设计能力和Sql编写能力，熟练使用Unix、Linux 运维，了解Docker、编排工具、自动化运维相关技术；\n5.熟悉分布式系统基础设施中常用的技术，如缓存、消息中间件、搜索引擎等；\n6.具有丰富的系统分析与架构设计实践经验，熟悉多线程、高并发、高可用性、高扩展性系统架构设计；\n7.熟悉PHP程序语言及相关知识优先。"
      },
      {
        'id': "s4",
        'name': "嵌入式Linux软件开发工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 负责无人机通信、网络、协议栈相关业务应用层功能开发;\n2. 负责无人机与其他模块通信协议的制定及文档编写。",
        'demand': "1.本科以上学历，电子工程、电子信息、自动化等相关专业；\n2.具备扎实的C/C++语言能力，优秀的软件架构能力和良好的编码风格；\n3.熟悉WIFI协议栈，有路由器开发经验优先；\n4.精通ARM平台开发，精通LINUX操作系统。"
      },
      {
        'id': "s5",
        'name': "软件测试工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 从事无人机及其相关产品的软件功能，兼容性、可靠性、性能等测试工作;\n2. 在需求分析、评审等阶段能够对需求提出合理的优化建议;\n3. 根据需求编写测试用例，制定测试计划，进行bug跟踪及确认，编写测试报告;\n4. 搭建自动化测试平台，设计自动化测试方案，高效完成软件测试工作。",
        'demand': "1.本科以上学历，具有3年以上软件测试经验；\n2.具备较强的逻辑思维能力和沟通能力，有良好的问题分析、解决能力；\n3.熟悉缺陷管理原则及流程，能够胜任敏捷迭代模式下的质量管理工作；\n4.熟悉Linux、Android、MySQL、http协议等知识；\n5.熟练使用常用工具，如：Fiddler、Charles、Postman、Jmeter、Jekins、Xshell等；\n6.有无人机、智能硬件等行业相关工作经验优先。"
      },
      {
        'id': "s6",
        'name': "行业销售经理",
        'area': "广东、浙江、江西、新疆",
        'edu': "专科",
        'station': "销售",
        'duty': "1.独立开拓公司无人机行业市场，开发、维护和挖掘销售机会；\n2.根据公司市场营销战略，积极完成销售量指标，扩大产品市场占有率；\n3.搭建政企合作关系，开拓维护经销商；\n4.协调公司内部资源，做好客户公关，与客户保持良好沟通，深度挖掘客户，为客户提供主动、热情、满意、周到的服务；\n5.根据公司产品价格体系及市场策略，处置询盘、报价、合同条款的协商及合作通签订事宜；\n6.把握市场，随时向公司提供市场分析及预测报告。",
        'demand': "1.大专及以上学历，具备2年以上的工业产品、高科技产品销售经验；\n2.较强的同行业信息收集获取能力，擅长商务拓展、谈判、执行力强；\n3.对无人机及无人机知识、技能及行业应用比较熟悉者优先；\n4.具有公安、消防、测绘、电力、石油、海事、军警背景资源者优先录用；\n5.热爱无人机行业。"
      },
      {
        'id': "s8",
        'name': "3D视觉设计师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "技术",
        'duty': "1.了解客户要求，构思无人机编队表演的前期方案，负责撰写提案和美术策划与创意工作，把控项目整体视觉风格；\n2.熟练掌握并使用设计软件制作无人机编队表演宣传材料；\n3.学习使用舞步设计软件制作无人机舞步造型。",
        'demand': "1.视觉传达、艺术设计等专业本科以上学历；\n2.三年以上互联网或广告行业视觉设计工作经验；\n3.熟练掌握常用的平面或三维设计软件，能够主导项目整体视觉风格；\n4.具有专业的美术创意基础，擅长创意策划，有手绘基础和字体设计经验，色彩搭配能力突出；\n5.擅长与客户进行方案沟通，具备较强的自学能力，能够持续优化团队输出。  "
      },
      {
        'id': "s9",
        'name': "装配工程师",
        'area': "北京",
        'edu': "专科",
        'station': "生产",
        'duty': "1. 按照无人机标准工艺流程进行产品装配；\n2. 解决装配中电路、结构等简单问题；\n3. 解决装配中线缆细节的结构连接问题。",
        'demand': "1.熟练掌握线缆、元器件焊接工艺；\n2.有电子产品组装、布线基础；\n3.有无人机类产品装配经验者优先；\n4.工作认真仔细，有责任心，可以承受一定的工作压力。"
      },
      {
        'id': "s10",
        'name': "飞行工程师",
        'area': "全国",
        'edu': "专科",
        'station': "飞手",
        'duty': "1.按照公司的战略计划辅助培训专员完成年度培训任务；\n2.负责学员的实践培训工作，包含模拟训练、实操训练、地面站教学的实践考试；\n3.不断总结教学经验，并改进教学方式、方法，提高教学质量和考试通过率；\n4.教学前后对无人机及配件进行保养、维修；\n5.进行演示并未客户提供培训，提供演示报告；\n6.执行部门安排的测试、演示飞行任务；\n7.参与产品开发过程的飞行相关评审工作；\n8.记录试飞结果；\n9.日常回答培训客户的技术问题；\n10.负责航飞相关的其他事项，例如空域报批、公安报备、现场安全预案等。",
        'demand': "1.具备多旋翼、固定翼、复合翼飞行经验，有多款机型操作经验；\n2.具有较强的适应和沟通能力，思路清晰、能够对外场突发情况进行处理和协调；\n3.能够适应出差工作，有吃苦精神。"
      },
      {
        'id': "s11",
        'name': "地面站软件开发工程师",
        'area': "北京",
        'edu': "本科",
        'station': "研发",
        'duty': "1.负责PC平台无人机地面站软件的开发与维护；\n2.负责无人机GIS系统的开发与维护；\n3.流媒体的软硬件开发与调试；\n4.持续地优化迭代产品的质量、性能、用户体验。",
        'demand': "1. 有GIS/WebGIS开发经验优先；\n2. 有无人机地面站开发经验优先；\n3. 有良好的编程基础，熟练掌握面向对象软件开发的基本思想和方法；\n4. 熟悉MySQL、SQL Server等常见数据库，并且具备较强的数据结构设计能力和经验。"
      },
      {
        'id': "s12",
        'name': "通信FPGA工程师",
        'area': "北京",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 负责FPGA端RTL代码的编写、仿真和调试；\n2. 协助硬件原理图工程师确定芯片选型、连接和管脚分配；\n3. 与软件工程师合作调试CPU和FPGA之间数据传输通道；\n4. 对公司现有产品代码进行维护升级。",
        'demand': "1. 了解FPGA基本结构、原理、开发流程，熟悉主流FPGA开发仿真工具、时序优化方法；\n2. 熟练掌握verilog代码编写和仿真；\n3. 熟悉UART、SPI、I2C、MII接口，熟悉FPGA的LVDS、GTP、DDR接口使用；\n4. 有在FPGA上实现通信信号处理经验者优先；\n5. 有使用过zynq系列芯片者经验优先。"
      }
    ]

  },
  'join_index': {
    'text1': '概览',
    'text2': '社会招聘',
    'text3': '校园招聘',
    'text4': '为了邀你加入',
    'text5': '我们每年飞行了上百万公里',
    'text6': '“有梦想、有活力、有激情、勇于创新”',
    'text7': '航翊科技由一群“有梦想、有活力、有激情、勇于创新”的年轻人组成',
    'text8': '“尊重、包容、发展”',
    'text9': '我们秉承“尊重、包容、发展”人才理念，努力为每一位加入我们的优秀人才提供施展才华的平台',
    'text10': '成为我们的一员',
    'text11': '我们一直在寻找“有梦想、有活力、有激情、勇于创新”的伙伴结伴同行，欢迎您的加入！',
    'text12': '校园招聘',
    'text13': '社会招聘',
  },
  'join_social': {
    'text1': '概览',
    'text2': '社会招聘',
    'text3': '校园招聘',
    'text4': '校招职位',
    'text5': '简历请发送至： hr@hovwing.com',
    'jobList': [
      {
        'id': "s1",
        'hot': 1,
        'name': "制导与控制算法工程师"
      },
      {
        'id': "s8",
        'hot': 1,
        'name': "3D视觉设计师"
      },
      {
        'id': "s6",
        'hot': 1,
        'name': "行业销售经理"
      },
      {
        'id': "s4",
        'hot': 0,
        'name': "嵌入式Linux软件开发工程师"
      },
      {
        'id': "s12",
        'hot': 0,
        'name': "通信FPGA工程师"
      },
      {
        'id': "s11",
        'hot': 0,
        'name': "地面站软件开发工程师"
      },
      {
        'id': "s2",
        'hot': 0,
        'name': "Web前端开发工程师"
      },
      {
        'id': "s3",
        'hot': 0,
        'name': "Java后端开发工程师"
      },
      {
        'id': "s5",
        'hot': 0,
        'name': "软件测试工程师"
      },
      {
        'id': "s10",
        'hot': 0,
        'name': "飞行工程师"
      },
      {
        'id': "s9",
        'hot': 0,
        'name': "装配工程师"
      },
      {
        'id': "s00",
        'hot': 0,
        'name': "更多职位请电话咨询"
      }
    ]
  },
  'support':{
    'text1':'help and support',
    text2:'Thank you for your continuous attention and support. We are very happy to provide assistance regarding your issues in drone selection, use, and maintenance',
    text3:'Contact Us',
    text4:'AS Service Center',
    text5:'7 days x 24 technical support',
    text6:'Address of after-sales service center',
    text7:'Rooms 101-102, East Side, 1st Floor, Huasheng Tiancheng Scientific Research Building, Haidian District, Beijing',
  },
  'contactNew': {
    'text1': 'Contact Us',
    'text2': 'Our experts can',
    'text3': 'Answer your questions about HOVERWING and our drones',
    'text4': 'Provide the best solution for your needs',
    'text5': 'Discuss partnership opportunities',
    'text6': 'Provide a product quote',
    'text7': 'Contact',
    'text8': 'TEL',
    'text8_1': '010-50947771',
    'text9': '(Monday-Friday 9:00 am – 6:00 pm GMT+8)',
    'text10': '+8618769471081   Aurora',
    'text11': '+8613220114637  Levey Liu',
    'text12': '+8613091439568  Hongxu cui',
    'text13': '+8613501233621 ابراهيم حسن',
    'text13_1': '+8613466409331 Susie',
    'text14': 'Email',
    'text15': 'Address',
    'text16': 'Rooms 101-102, East Side, 1st Floor, Huasheng Tiancheng Scientific Research Building, Haidian District, Beijing, China',
    'text17': 'Name',
    'text18': 'Email',
    'text18_1': 'sales@hovwing.com',
    'text19': 'Phone',
    'text20': 'Company',
    'text21': 'Region',
    'text22': 'Message',
    'text23': 'Subscribe to HOVERWING newsletter. You can unsubscribe at any time By submitting this form, you accept the',
    'text24': 'Privacy Policy',
    'text25': 'and',
    'text26': 'Terms & Conditions',
    'text27': 'Submit',
    'text28': 'Submission successful',
    'text28_1': 'Thank you for your feedback',
    'text29': 'Please fill in your name',
    'text30': 'Please fill in your email',
    'text31': 'Please fill in the phone number',
    'text32': 'Please fill in the company',
    'text33': 'Please fill in the area',
    'text34': 'Please leave a message',
  },
  'termsConditions':{
    'text1':'TERMS & CONDITIONS',
    'text2':'All HOVERWING website belongs to HOVERWING (Beijing Hoverwing Technology Co., Ltd,) and is a limited liability company established under the laws of the People\'\s Republic of China.  ',
    'text2_1':'Wangdong Road, Haidian District, Beijing, China',
    'text3':'Accept the Terms of Use',
    'text4':'By visiting and using any HOVERWING website, you agree to be bound by the current terms of use. All terms and conditions quoted herein or any additional terms and conditions stipulated on any website shall be deemed acceptable to you. If you do not agree with the current terms of use, you should not use this website or any HOVERWING website.',
    'text5':'These Terms of Use may be amended by HOVERWING at any time. The revised conditions of use shall take effect when they are published on this website or any other HOVERWING website. Please check the terms of use published on our website regularly to ensure that you understand all the terms and conditions governing your use of these sites. Other HOVERWING websites may have their own terms of use that apply to themselves. In addition, specific terms and conditions may apply to specific content, products, materials, services or information contained in or provided through this website. Such specific clauses may be supplementary to these terms of use, or, as long as the contents or intentions of these specific clauses are inconsistent with those contained in these terms of use, such specific clauses will replace these terms of use.',
    'text6':'HOVERWING has the right to change or update the content or format of the website at any time. HOVERWING has the right to terminate or restrict access to any website for any reason at its own discretion.',
    'text7':'Privacy Policy',
    'text8':'Collecting and processing personal data through any HOVERWING website conforms to our Privacy Policy and Data Protection Regulations. For more details, please read our Privacy Policy.',
    'text8_1':'Read More',
    'text9':'Intellectual Property',
    'text10':'The name and logo of HOVERWING are our registered trademarks. Products and accessories of HOVERWING are protected by intellectual and industrial property rights, including trademarks, models and patents. The copyright and all other ownership rights of the content of any HOVERWING website (including models, drawings, photos, texts, audio, video and graphics) belong to the only property of HOVERWING or its licensor, in which any part of the content used or published is licensed. All other trademarks and logos that do not belong to HOVERWING are the property of their respective owners.',
    'text11':'Photos posted on our website are protected by copyright and are the property of their respective owners.',
    'text12':'The content published on the www.HOVERWING.com website can be used in an unmodified form for the only purpose of operating HOVERWING < products by registered and approved members of these websites in accordance with the licensing agreement.',
    'text13':'Contents published on www.HOVERWING.com websites can be copied or distributed in an unmodified format for registration and approval of members of these websites or support services only. Commercial use or support service use of this content can only satisfy the interests of HOVERWING and HOVERWING distributors under the authorization of us. We strictly forbid anyone to embezzle this content from its original purpose.',
    'text14':'Except some regulation, any content published on any HOVERWING website can be copied or distributed in an unmodified form and used only for personal non-commercial purposes. The use of content in any other way, including but not limited to distribution, reproduction, modification, display, translation, adaptation or dissemination, is strictly prohibited without the prior written consent of HOVERWING.',
    'text15':'All copies shall retain its copyright and other ownership declarations.',
    'text16':'Disclaimer',
    'text17':'Although we have done our best to ensure the accuracy of the information published on any HOVERWING website, including its content and functions, to the maximum extent permitted by law, we provide any content as it is. Therefore, you are at your own risk of using any website. We hereby expressly reject any express or implied statement or guarantee, including, but not limited to, marketability, applicable to any particular purpose, without infringement or operation of its website or its content. We do not guarantee or make any statement about the security of this website. You acknowledge any information that may be intercepted.',
    'text18':'In any conditions, there is not responsible for indirect, punitive, special or incidental damage (including but not limited to damage caused by business losses, contracts, revenue, data, information or business interruptions) under any conditions, and therefore, due to the use or inability to use its website or its content, or related to this, even if the possibility of such damage has been told. Any act of interest in or related to its website must be notified in writing within one (1) year of the reason for the action. Since some jurisdictions do not allow the exclusion or limitation of consequential or collateral damage, part or all of the previous sentence may not apply to you.',
    'text19':'HOVERWING website may contain links to other sites that are not controlled by HOVERWING. Such links are provided to you only for convenience, and HOVERWING does not have any responsibility for the content or function of any such linking website. HOVERWING does not guarantee the accuracy, legitimacy, reliability or validity of the contents and functions of all such linked websites without any explicit or implied guarantee. Additionally, HOVERWING neither recognizes nor recommends any such linking sites.',
    'text20':'Contact',
    'text21':'If you want to know more about HOVERWING, modify your personal data or have any questions, comments, suggestions on this statement, or need to ask for your personal data, contact us via contact@HOVERWING.com.',
    'text22':'Important Note: Due to local laws and language differences, the local language version of Privacy Policy may be different from this version. If there are any differences, please refer to the local language version.',
    'text23':'Latest update: December 18, 2023',
  },
  'privacyPolicy':{
    'text1':'PRIVACY POLICY',
    'text2':'Beijing Hoverwing Technology Co., Ltd,is a limited liability company established in accordance with the laws of the People\'s Republic of China (collectively, "HOVERWING”", "we", "us", and "our", including HOVERWING\'s affiliates ). We attach great importance to the maintenance and protection of your personal data. When you use HOVERWING\'s products and services, we may collect and use your personal data. This Privacy Policy aims to describe how HOVERWING collect, store, use or share your personal data. Please read this Privacy Policy carefully so that you can make the right choice when you need it.',
    'text3':'Your use or continued use of our products or services means that you agree HOVERWING to collect, store, use and share your personal data in accordance with this Privacy Policy.',
    'text4':'How We Collect Your Personal Data',
    'text5':'The date you provide to HOVERWING in the process of using HOVERWING products or services, such as name, phone number, e-mail address, communication address, ID number, bank card number (which you need to provide when you make payment transactions with HOVERWING), flight data (including sensor data, navigation system data, devices data, control data, flight restriction data and environmental perception visual data, as you request HOVERWING to provide after-sales service) etc.The data are read or stored by the system when you use our products or services, such as your location, product log, configuration information of your electronic equipment, flight data, IP address of access to our products or services, time information, geographic environment and location information, shared text or pictures, etc.',
    'text6':'Your personal information may contain sensitive information, such as your race, religion, personal health condition, gender orientation, etc. When you use our products or services, you may upload or publish such sensitive information through open channels. Please handle these information with caution.',
    'text7':'How We Use & Disclose Personal Data',
    'text8':'We may use your personal information to help us achieve following purposes:',
    'text9':'Serve you. Help us design new products or services, improve our existing products or services. And for identification, customer service, security, archive or backup, etc. Provide you with more closely related advertisements. Let you participate in our product or service survey. We may commission other third parties to provide services on behalf of HOVERWING, such as data processing, account management and marketing. We only provide these third parties with the information they need to complete their services, and we sign confidentiality agreements with these third parties with the same standards of confidentiality of HOVERWING. These third parties may come from abroad. According to the location laws, these third parties may have certain obligations of information disclosure.We will not share your personal information with any third party, except following conditions: ',
    'text10':'With your agreement: to achieve the purpose of chapter of “How may we use your personal data?” that share your information with HOVERWING authorized product or service providers. Share your personal information within HOVERWING to achieve the purpose of chapter of "How may we use your personal data?"',
    'text11':'In the future, we may sell HOVERWING Business or acquire new business. In this case, your personal information and related accounts, products and services you purchased will be transferred along with the business.',
    'text12':'Your personal data may be required to be disclosed under the following conditions: 1) to disclose to judicial or law enforcement agencies in order to investigate and prevent crime when suspected of criminal activities; 2) to disclose in accordance with the mandatory requirements of the law (or the court); 3) to disclose in accordance with the mandatory requirements of the government; 4) to protect HOVERWING assets (such as liquidating overdue payments and Accounts) etc. In the above case, we will record the content, time, reason and object of data disclosure.',
    'text13':'Your Authorities',
    'text14':'If you want to check or verify your personal information and our disclosure records, please contact our customer manager or distributor. If in some cases we are unable to provide relevant information, we will inform you of the reasons in time.',
    'text15':'In some cases, you have the right to refuse to provide us with certain data, but we may not be able to provide you with certain products, services or information. In order to protect the interests of both parties, for example, to ensure that your requirements are implemented and to prove that we have provided you with the required information, we may monitor your telephone or email contacts with HOVERWING, in order to ensure the quality of our service.',
    'text16':'If you do not want to receive our communication on direct marketing, please let us know that we will delete your personal information from the direct marketing list.',
    'text17':'If you do not want to share your personal information within HOVERWING members, please inform us. In this condition, we may not provide you certain products or services due to lack of information.',
    'text18':'If you are under the age of 18, you should obtain the consent and guidance of your parents or guardians to ensure the correct use of our products and services.',
    'text19':'According to the laws of your region, some of the provisions of this Privacy Policy may not apply to you. This Privacy Policy does not exclude or restrict any of your rights under local law.',
    'text20':'Cookie',
    'text21':'When you visit our website, the files will be placed on your terminal. These files called cookies, are designed to gather data about your browsing and enable us to focus on your needs and expectations. For example, we use Cookie to identify you and access your my. Hoverwing account.',
    'text22':'This section allows you to better understand how Cookie works and how to configure it using current tools.',
    'text23':'Updates to This Policy',
    'text24':'We may amend the provisions of the Privacy Policy in due course, which form part of the Privacy Policy. If such amendments result in a substantial reduction of your rights under this Privacy Policy, we will notify you in a prominent place on the home page or send you an e-mail or otherwise before the amendment takes effect. In this case, if you continue to use our services, means you agree to be bound by the revised Privacy Policy.',
    'text25':'Our Commitments',
    'text26':'HOVERWING appreciates that has the opportunity to provide you products and services. Since the establishment of HOVERWING, winning and maintaining your trust has always been our service purpose. We are committed to respecting and protecting the privacy and personal data you provide. We also hope that you will understand our privacy policy, including how to collect, use and disclose your personal data.',
    'text27':'We appoint a team to manage your personal data protection, including system, dispute resolution, training, liaison and other aspects, and report directly to the board of directors and the general manager on privacy protection related matters.',
    'text28':'We will ensure that when you apply for any product or service, you will be informed of the purpose of the above information collection. If we want to use your personal information for other purposes, we will apply to you.',
  },
  'notfound': {
    'text1': '页面走丢了',
    'text2': '返回首页',
  },

  // v2
  fayj:{
    "text1": "Emergency",
    "text2": "Solution",
    "text3": "Application case",
    "list1": [
      {
        "title": "The challenges facing the entire industry",
        "info": [
          "In the scenarios of mountains, valleys and the situation of \"three breaks\" (broken communication, broken road, broken power supply), weak communication capabilities can easily lead to interruptions.",
          "In emergency situations, high timeliness of rescue is required, and prompt responses are necessary.",
          "Poor communication of emergency information can easily form \"information islands\"."
        ]
      },
      {
        "title": "Our program advantages",
        "info": [
          "The medium-sized composite wing UAS can carry photoelectric pods, airborne satellite communication and other loads, and it can quickly establish an aerial communication \"life infra\" and break through the \"communication islands\".",
          "Medium-sized composite wing UAS have the characteristics of vertical takeoff and landing, long coverage distance, long battery life, and stronger capabilities to reach the emergency rescue scene first.",
          "The real-time images of the disaster area can be connected to the unified emergency command and coordination platform, and the live video images can be broadcast online 24 hours a day, providing key information support for rescue operations."
        ]
      }
    ],
    "list2": [
      {
        "url": "/static/images/v2/hyfa/fa_fly.png",
        "title": "Medium composite wing UAS platform",
        "info": [
          "ZT-120V",
          "ZT-60V",
          "ZT-25V",
          "ZT-16V",
          "ZT-13V",
          "ZT-25V",
          "ZT-60VS"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rj.png",
        "title": "Software Products",
        "info": [
          "Inspection Assistant",
          "Yunxun",
          "Dowell"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rwzh.png",
        "title": "Mission Load",
        "info": [
          "Electro-optical Pod",
          "Surveying and Mapping Camera",
          "Airborne PDT Cluster Base Station",
          "LIDAR",
          "Airborne Public Network Base Station",
          "Airborne Personnel Search and Rescue Payload",
          "Airborne Satellite Communication Equipment",
          "Fast 3D Modeling Payload"
        ]
      }
    ],
    "list3": [
      {
        "url": "/static/images/v2/hyfa/yj_al1.png",
        "title": "Emergency Rescue for Typhoon \"Mojie\" in Hainan on September 6th",
        "info": "At 16:20 on September 6, 2024, the super typhoon \"Capricorn\" made landfall in the coastal area of Wenchang City, Hainan Province. On September 7, the ZT-120V medium-sized composite wing UAS, equipped with a three-network public network base station, took off from Jiazi Airport in Ding'an County, Haikou City and flew to Sanjiang Town, Haikou City under the condition of an 8-level wind speed in the air. It provided emergency communication and disaster reconnaissance for the rescue of the disaster area and became the first rescue force to deal with the super typhoon \"Capricorn\". During the rescue period, the ZT-120V medium-sized composite wing drone was dispatched for 3 sorties, with a cumulative flight support time of 622 minutes, a cumulative flight distance of 987 kilometers, a public network coverage area of about 785 square kilometers, 3,310 active users, 434 successful calls, 6072.95M of downstream traffic, and 2454.28M of upstream traffic. The video footage of the disaster area was sent back to the aviation emergency rescue command and dispatch platform of the Hainan Provincial Emergency Management Department in real time, providing key support for the emergency communication of the general public and the decision-making and deployment of the command."
      },
      {
        "url": "/static/images/v2/hyfa/yj_al2.png",
        "title": "Forest Fire in Chengxiang Village, Hekou Town, Yajiang County, Ganzi Tibetan Autonomous Prefecture, Sichuan Province",
        "info": "On December 9, 2024, a forest fire broke out in Chengxiang Village, Hekou Town, Yajiang County, Ganzi Tibetan Autonomous Prefecture, Sichuan Province. After the fire broke out, the ZT-120V drone rescue team immediately launched an emergency response and quickly rushed to participate in the rescue, becoming the first composite wing drone rescue force to arrive above the fire site. During the rescue, the ZT-120V medium-sized composite wing drone, equipped with airborne satellite communication equipment and optoelectronic pods, took off from Xinduqiao Town, which is 40 kilometers away from the fire site. A total of 2 sorties were dispatched, with a total flight support time of 390 minutes. The fire site was surveyed and inspected at an altitude of 5000 meters above sea level, and the area within 20 square kilometers of the fire area was inspected. The scene images and infrared video images of the fire were sent back to the aviation emergency rescue command and dispatch platform of the Sichuan Provincial Emergency Management Department in real time, providing key information support for the headquarters to fully reconnoiter the fire situation, scientifically command and make decisions to safely extinguish the fire."
      }
    ]
  } ,
  fany:{
    "text1": "Energy",
    "text2": "Solution",
    "text3": "Application case",
    "list1": [
      {
        "title": "The challenges facing the entire industry",
        "info": [
          "It is necessary to face harsh environmental conditions such as extreme temperatures, strong winds, rainfall, and snowfall.",
          "Traditional inspection methods cannot break through the limitations of time and space, resulting in low inspection efficiency and high costs.",
          "With traditional inspection methods, data collection is incomplete, and there is a lack of effective data collection methods.\nOur program advantages"
        ]
      },
      {
        "title": "Our program advantages",
        "info": [
          "Medium-sized composite wing UAS have the capability to withstand wind, rain, and snow weather. They can be used in complex meteorological environments and are applicable to diverse terrains such as mountainous areas, rivers, and the Gobi Desert.",
          "The medium-sized composite wing UAS can break through the constraints of time and space and can quickly carry out inspection operations around the clock, greatly improving the work efficiency of inspections.",
          "Medium-sized composite wing UAS are equipped with high-resolution cameras and advanced sensors, which can achieve high-precision monitoring of power equipment and provide more detailed and comprehensive data information."
        ]
      }
    ],
    "list2": [
      {
        "url": "/static/images/v2/hyfa/fa_fly.png",
        "title": "Medium composite wing UAS platform",
        "info": [
          "ZT-120V",
          "ZT-60V",
          "ZT-25V",
          "ZT-16V",
          "ZT-13V",
          "ZT-25V",
          "ZT-60VS"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rj.png",
        "title": "Software Products",
        "info": [
          "Inspection Assistant",
          "Yunxun",
          "Dowell"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rwzh.png",
        "title": "Mission Load",
        "info": [
          "Electro-optical Pod",
          "Surveying and Mapping Camera",
          "Airborne PDT Cluster Base Station",
          "LIDAR",
          "Airborne Public Network Base Station",
          "Airborne Personnel Search and Rescue Payload",
          "Airborne Satellite Communication Equipment",
          "Fast 3D Modeling Payload"
        ]
      }
    ],
    "list3": [
      {
        "url": "/static/images/v2/hyfa/ny_al1.png",
        "title": "UAV Flood Control Emergency Inspection of Transmission Lines",
        "info": "China Netcom uses the XXX medium-sized composite wing UAS to conduct UAV flood control emergency inspections on important transmission lines in Chizhou and Jiuhua, Anhui. This is the first time that State Grid has used medium and large-sized composite wing UAVs to carry out emergency inspections for power grid flood control. Through real-time image transmission, UAV-to-UAV relay, etc., various inspection tasks are efficiently completed. The emergency inspection tasks provide a strong guarantee for the safe and stable operation of the power grid."
      },
      {
        "url": "/static/images/v2/hyfa/ny_al2.png",
        "title": "Composite Wing UAV Performs Power Grid Line Inspection at an Altitude of 4500 Meters",
        "info": "The large and medium-sized UAV high plateau demonstration operation was jointly carried out by China Netcom Airlines and State Grid Tibet Maintenance Company. The demonstration operation used the XXX composite wing UAS to perform power grid line inspection operations at an altitude of 4500 meters. It carried out subjects such as conventional laser inspection, night laser inspection, disaster emergency census, infrared patrol, and infrared night patrol on the power system of State Grid Tibet Power, achieving 24-hour all-weather operation. This operation refreshed the inspection records of many plateau UAVs at home and abroad."
      }
    ]
  } ,
  falc:{
    "text1": "Forestry and Grassland",
    "text2": "Solution",
    "text3": "Application case",
    "list1": [
      {
        "title": "The challenges facing the entire industry",
        "info": [
          "The forest and grassland site conditions are complex, and it is difficult for personnel to reach the site quickly. There are monitoring blind spots in traditional patrol methods, which cannot achieve full coverage.",
          "The forest and grassland sites cover a wide range, with many hidden threats of mountain fires. Fire prevention and control are difficult, the efficiency of fire suppression is low, and the safety guarantee is weak.",
          "The traditional inspection method has low patrol efficiency, poor timeliness, and cannot achieve effective patrol. The collected data is single, and the update frequency is low."
        ]
      },
      {
        "title": "Our program advantages",
        "info": [
          "The medium-sized composite wing UAS has the ability to withstand wind, rain, and snow weather, and can be used in diverse terrains such as mountainous areas, rivers, and plateaus, enabling full coverage of forest and grassland flight patrols.",
          "Medium-sized composite wing UAS can break through time and space limitations, with high inspection efficiency. They can carry task loads, obtain real-time high-definition visual images, and improve the efficiency of fire prevention and extinguishing.",
          "The medium-sized composite wing UAS is equipped with lidar, which can effectively meet the surveying and mapping requirements such as forest and grassland resources surveys. It is also equipped with high-spectral and multi-spectral cameras to realize geological surveys, vegetation identification and classification, and monitoring of vegetation diseases and pests."
        ]
      }
    ],
    "list2": [
      {
        "url": "/static/images/v2/hyfa/fa_fly.png",
        "title": "Medium composite wing UAS platform",
        "info": [
          "ZT-120V",
          "ZT-60V",
          "ZT-25V",
          "ZT-16V",
          "ZT-13V",
          "ZT-25V",
          "ZT-60VS"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rj.png",
        "title": "Software Products",
        "info": [
          "Inspection Assistant",
          "Yunxun",
          "Dowell"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rwzh.png",
        "title": "Mission Load",
        "info": [
          "Electro-optical Pod",
          "Surveying and Mapping Camera",
          "Airborne PDT Cluster Base Station",
          "LIDAR",
          "Airborne Public Network Base Station",
          "Airborne Personnel Search and Rescue Payload",
          "Airborne Satellite Communication Equipment",
          "Fast 3D Modeling Payload"
        ]
      }
    ],
    "list3": [
      {
        "url": "/static/images/v2/hyfa/lc_al1.png",
        "title": "ZT-25V UAV Performs Forest and Grassland Aerial Firefighting Task for a Provincial Forestry and Grassland Fire Prevention Center",
        "info": "The ZT-25V drone performs the forest and grassland aerial firefighting task for a provincial forestry and grassland fire prevention center. During the task, the ZT-25V UAS flew 633 sorties, with a flight time of 1020.93 hours, a total patrol area of 7.38 million acres, a total flight mileage of approximately 81,680 kilometers, and a cumulative patrol area of approximately 220.05 million acres."
      },
      {
        "url": "/static/images/v2/hyfa/lc_al2.png",
        "title": "ZT-25V UAV Detects Fire Starting Points in Forest Areas Multiple Times",
        "info": "The ZT-25V is equipped with a special camera to perform patrol monitoring tasks, transmit image information in real time, and conduct intelligent identification and early warning of fire situations, providing a basis for the decision-making and deployment of the emergency command center and gaining valuable time for forest firefighting. During the patrol, the ZT-25V drone detected fire starting points in forest areas and abnormal situations such as grazing people, fishing people, swimmers, vehicles, and wild animals multiple times, and reported them to the forest farm leaders and staff in a timely manner."
      },
      {
        "url": "/static/images/v2/hyfa/lc_al3.png",
        "title": "According to the Analysis and Evaluation Results of the Forest and Grassland Fire Risk Census, Combined with the Full Implementation of the National Forest Chief System",
        "info": "According to the analysis and evaluation results of the forest and grassland fire risk census, combined with the full implementation of the national forest chief system, this task divides the forest and grassland fire risk area into standard square grids, establishes a UAV grid patrol mechanism, and draws a map of UAV aerial fire protection in forest farms. This effectively reduces patrol blind spots, improves patrol efficiency, and effectively enhances the ability and digital level of forest and grassland fire safety prevention."
      }
    ]
  } ,
  faga:{
    "text1": "Public Security",
    "text2": "Solution",
    "text3": "Application case",
    "list1": [
      {
        "title": "The challenges facing the entire industry",
        "info": [
          "Faced with the complex and changeable public security situation and insufficient allocation of police resources, it is difficult to conduct effective patrol and management.",
          "The patrol area is large, the law enforcement radius is long, and it is difficult for personnel to arrive quickly.",
          "The inspection data collection is limited in variety, with a low utilization rate. It is unable to conduct comprehensive analysis, and it is difficult to trace and review historical data.\nOur program advantages:"
        ]
      },
      {
        "title": "Our program advantages",
        "info": [
          "UAS can easily fly over complex terrains and hard-to-reach areas, providing a broader perspective and comprehensive view for security prevention and control.",
          "UAS can be deployed quickly, greatly shortening the time from detection to response and enabling them to quickly reach the scene.",
          "By installing different mission loads, UAS can quickly survey, record, fix on-site evidence, and collect on-site data at high altitudes."
        ]
      }
    ],
    "list2": [
      {
        "url": "/static/images/v2/hyfa/fa_fly.png",
        "title": "Medium composite wing UAS platform",
        "info": [
          "ZT-120V",
          "ZT-60V",
          "ZT-25V",
          "ZT-16V",
          "ZT-13V",
          "ZT-25V",
          "ZT-60VS"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rj.png",
        "title": "Software Products",
        "info": [
          "Inspection Assistant",
          "Yunxun",
          "Dowell"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rwzh.png",
        "title": "Mission Load",
        "info": [
          "Electro - optical Pod",
          "Surveying and Mapping Camera",
          "Airborne PDT Cluster Base Station",
          "LIDAR",
          "Airborne Public Network Base Station",
          "Airborne Personnel Search and Rescue Payload",
          "Airborne Satellite Communication Equipment",
          "Fast 3D Modeling Payload"
        ]
      }
    ],
    "list3": [
      {
        "url": "/static/images/v2/hyfa/ga_al1.png",
        "title": "Normalized Urban Patrol Application of UAVs in Weihai, Shandong",
        "info": "The urban roaming plan of the Special Patrol Detachment of Weihai Public Security Bureau in Shandong Province employs a composite wing UAS to conduct a \"Global Roaming Base Station + Composite Wing UAV\" global cruise. Upon receiving the order, the composite wing UAS can take off from the Special Patrol Detachment within 3 minutes and reach any designated location in the city within 20 minutes. This solves the problem that the large coverage area and numerous obstructions in the city are not conducive to inspections. It realizes all-weather drone monitoring without blind spots and provides accurate data to the command center in real time."
      },
      {
        "url": "/static/images/v2/hyfa/ga_al2.png",
        "title": "Xiangcheng District, Suzhou City Adopts ZT-25V Vertical Takeoff and Landing Fixed-wing UAV",
        "info": "Xiangcheng District, Suzhou City adopts the ZT-25V VTOL (Vertical Takeoff and Landing) fixed-wing UAS and has designed the first police-hangar fixed-wing UAS airport in Jiangsu Province, which greatly shortens the pre-takeoff preparation time. With a single click to start, the ZT-25V UAS can quickly slide out of the hangar, take off rapidly, and reach the scene 8 kilometers away. The whole process takes less than 10 minutes. Through the real-time returned images along the 20-kilometer main road, the on-site police in the command hall carried out traffic dredging, quickly clearing the main road and ensuring the smooth flow of the morning peak traffic. The cruising area has been expanded from Xiangcheng District to the entire area of Suzhou, achieving remote control, rapid response, and efficient linkage. In addition, the ZT-25V UAS, together with the police drone command combat cabin and the multi-rotor units of each police station, forms a police aviation \"1 + 1 + N\" working system, which greatly enhances the combat effectiveness of the drone police aviation force."
      }
    ]
  } ,
  fach:{
    "text1": "Surveying and Mapping",
    "text2": "Solution",
    "text3": "Application case",
    "list1": [
      {
        "title": "The challenges facing the entire industry",
        "info": [
          "Traditional surveying and mapping methods have limitations. It is difficult to access complex terrain environments such as mountains, valleys, swamps, and forests.",
          "Large-scale mapping is time-consuming and demands a substantial investment of manpower, resources, and time.",
          "The cost of data acquisition is high. Traditional surveying and mapping methods involve large and heavy equipment that requires professional operation, thus resulting in high costs.",
          "There is insufficient data accuracy and timeliness. In a dynamically changing scenario, it is challenging for traditional mapping methods to update data in a timely manner."
        ]
      },
      {
        "title": "Our program advantages",
        "info": [
          "The UAS can be assembled, commissioned, and made ready for takeoff in a short period, allowing for rapid deployment and operation in complex terrain environments.",
          "UAS surveying and mapping can quickly cover a large area, significantly shortening the surveying and mapping cycle and reducing project operation costs.",
          "The UAS is capable of carrying a variety of high-precision mapping sensors to acquire high-precision 3D terrain data and generate various types of data results.",
          "The UAS can conduct regular surveying and mapping to obtain dynamically changing data, ensuring the timeliness of the data. Through the analysis of these data, potential security risks can be detected promptly."
        ]
      }
    ],
    "list2": [
      {
        "url": "/static/images/v2/hyfa/fa_fly.png",
        "title": "Medium composite wing UAS platform",
        "info": [
          "ZT-120V",
          "ZT-60V",
          "ZT-25V",
          "ZT-16V",
          "ZT-13V",
          "ZT-25V",
          "ZT-60VS"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rj.png",
        "title": "Software Products",
        "info": [
          "Inspection Assistant",
          "Yunxun",
          "Dowell"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rwzh.png",
        "title": "Mission Load",
        "info": [
          "Electro-optical Pod",
          "Surveying and Mapping Camera",
          "Airborne PDT Cluster Base Station",
          "LIDAR",
          "Airborne Public Network Base Station",
          "Airborne Personnel Search and Rescue Payload",
          "Airborne Satellite Communication Equipment",
          "Fast 3D Modeling Payload"
        ]
      }
    ],
    "list3": [
      {
        "url": "/static/images/v2/hyfa/ch_al1.png",
        "title": "Three-dimensional Real-scene Modeling of the Great Wall",
        "info": "By using the ZT series composite wing UAS in combination with 3D real-scene modeling technology, high-precision (1cm resolution) 3D data of the Great Wall can be quickly obtained, which facilitates the further protection and restoration of the Great Wall."
      },
      {
        "url": "/static/images/v2/hyfa/ch_al2.png",
        "title": "Using UAV Oblique Photography Technology to Rapidly Acquire Geographical Information of Abandoned Mines",
        "info": "A certain unit, by adopting UAS oblique photography technology, can quickly obtain the geographical information of abandoned mines. The generated true 3D model enables the rapid acquisition of low-cost and high-precision basic information for mine ecological restoration, providing reliable technical and data support for the reclamation of abandoned mine land and ecological restoration construction."
      }
    ]
  },
  fasl:{
    "text1": "Water Conservancy",
    "text2": "Solution",
    "text3": "Application case",
    "list1": [
      {
        "title": "The challenges facing the entire industry",
        "info": [
          "In complex terrains, such as steep hillsides along rivers and swampy areas, it is difficult for staff to reach the sites using traditional patrol methods.",
          "In the face of sudden disasters like river pollution and floods, traditional inspection methods are unable to detect and report the situations in a timely manner.",
          "Due to the efficiency limitations of traditional patrol methods, the regular inspection cycle is usually long, making it impossible to keep track of the changes in the patrol area within a short period."
        ]
      },
      {
        "title": "Our program advantages",
        "info": [
          "UAS can fly over complex terrains including forests, mountains, and swamps, greatly enhancing the efficiency and coverage of inspections.",
          "During the inspection process, the UAS transmits the collected data back to the ground control center in real time, enabling the staff to be aware of the changes in the area immediately.",
          "Equipped with mission loads, the UAS can conduct accurate data collection and analysis, providing strong data support for subsequent governance and maintenance work."
        ]
      }
    ],
    "list2": [
      {
        "url": "/static/images/v2/hyfa/fa_fly.png",
        "title": "Medium composite wing UAS platform",
        "info": [
          "ZT-120V",
          "ZT-60V",
          "ZT-25V",
          "ZT-16V",
          "ZT-13V",
          "ZT-25V",
          "ZT-60VS"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rj.png",
        "title": "Software Products",
        "info": [
          "Inspection Assistant",
          "Yunxun",
          "Dowell"
        ]
      },
      {
        "url": "/static/images/v2/hyfa/fa_rwzh.png",
        "title": "Mission Load",
        "info": [
          "Electro-optical Pod",
          "Surveying and Mapping Camera",
          "Airborne PDT Cluster Base Station",
          "LIDAR",
          "Airborne Public Network Base Station",
          "Airborne Personnel Search and Rescue Payload",
          "Airborne Satellite Communication Equipment",
          "Fast 3D Modeling Payload"
        ]
      }
    ],
    "list3": [
      {
        "url": "/static/images/v2/hyfa/sl_al1.png",
        "title": "Normalized Inspection of the Changzhou Section of the Beijing-Hangzhou Grand Canal",
        "info": "The customer utilized our composite wing UAS to carry out regular inspections on the Changzhou section of the Beijing-Hangzhou Grand Canal. Visible light was used to monitor illegal constructions along the river, and outdoor and spectral cameras were employed to comprehensively monitor water pollution, achieving satisfactory results."
      },
      {
        "url": "/static/images/v2/hyfa/sl_al2.png",
        "title": "Composite Wing UAV Undertakes the Normalized Inspection of River Channels in Suzhou City",
        "info": "Since 2020, our composite wing UAS has been undertaking the normalized inspection of river channels in Suzhou City. The drone is equipped with a dual-light pod, which uses visible light to monitor illegal constructions along the river and an infrared load to monitor illegal discharge pollution, achieving excellent results."
      }
    ]
  },
  hw600:{
    text1:'Unmanned Helicopter',
    text2:'Payload',
    text3:'Endurance',
    text4:'Video Transmitting',
    text5:'The HW-600H is a large-payload long-endurance transport unmanned helicopter. The power system adopts an autonomous controllable oil-powered engine, the fuselage adopts a tandem layout, with a compact structure and high load efficiency. The avionics equipment adopts triple redundancy safety flight control, and has a dual navigation system of satellite navigation and visual fusion navigation. Combined with an autonomous obstacle avoidance system based on lidar to fully guaranted flight safety.',
    text6:'Strong load capacity',
    text7:'The HW-600H adopts an advanced power system with superior performance and strong power, with a comprehensive load capacity of 200 + kg',
    text8:'Long battery life',
    text9:'HW-600H adopts a column layout structure, with stronger rotor lift, higher hovering efficiency, and a battery life of up to 8 hours。',
    text10:'Large center of gravity',
    text11:'The HW-600H rotor adopts a front-to-back layout, and the hanging center of gravity has a large range, which can quickly and efficiently complete cargo loading and unloading operations',
    text12:'Autonomous sensory obstacle avoidance',
    text13:'HW-600H has the ability of autonomous perception and obstacle avoidance to ensure the flight safety of drones in all-weather and complex environments.',
    text14:'Strong anti-interference ability',
    text15:'The HW-600H supports visual inertial navigation fusion navigation flight mode, which can maintain safe flight in the environment of deception, signal interference or satellite rejection.',
    text16:'Airworthiness certification',
    text17:'The HW-600H unmanned helicopter has been successfully accepted for airworthiness certification by the Southwest Regional Administration of Civil Aviation of China. The HW-600H is also the first unmanned helicopter to be applied for and accepted based on the AP-21-71 airworthiness certification management procedure. Work related to airworthiness certification is currently underway',
    text18:'mission load',
    text19:'Parameters',
    taskLoad: [
      {
        title: "Detection load",
        list: [
          {
            name: 'GD3035',
            url: '/static/images/v2/600h/600h_logo1.png',
            url_load: '/static/images/v2/600h/600h_load1.png',
            info: [
              'Weight: 0.70kg',
              'Visible light camera: 30x optical zoom',
              'Infrared camera: Uncooled vanadium oxide focal plane array',
              'Infrared camera focal length: 35mm'
            ]
          },
          {
            name: 'GT3035L',
            url: '/static/images/v2/600h/600h_logo2.png',
            url_load: '/static/images/v2/600h/600h_load2.png',
            info: [
              'Weight: 0.75kg',
              'Visible light camera: 30x optical zoom',
              'Infrared camera: Uncooled vanadium oxide focal plane array',
              'Infrared camera focal length: 35mm',
              'Laser rangefinder: 15 - 3000m',
              'Real - time target positioning accuracy: <30m@1000m'
            ]
          },
          {
            name: 'PT3075I',
            url: '/static/images/v2/600h/600h_logo3.png',
            url_load: '/static/images/v2/600h/600h_load3.png',
            info: [
              'Weight: 2.90kg',
              'Visible light camera: 30x optical zoom',
              'Infrared camera: Uncooled vanadium oxide focal plane array',
              'Infrared camera focal length: 75mm',
              'Laser rangefinder: 50 - 6000m',
              'Real - time target positioning accuracy: Better than 2m@1000m',
              'Built - in high - precision inertial navigation module'
            ]
          }
        ]
      },
      {
        title: "Fire fighting load",
        list: [
          {
            name: 'Airborne bucket',
            url: '/static/images/v2/600h/600h_logo4.png',
            url_load: '/static/images/v2/600h/600h_load4.png',
            info: [
              'Maximum capacity: 200L',
              'Release flow rate: 40L/S',
              'Water intake method: Cruise water intake from open water sources'
            ]
          },
          {
            name: 'Fire extinguishing water tank',
            url: '/static/images/v2/600h/600h_logo5.png',
            url_load: '/static/images/v2/600h/600h_load5.png',
            info: [
              'Maximum capacity: 150L',
              'Spray distance: 20m',
              'Spray direction: Adjustable up and down'
            ]
          },
          {
            name: 'Special fire extinguishing bomb',
            url: '/static/images/v2/600h/600h_logo6.png',
            url_load: '/static/images/v2/600h/600h_load6.png',
            info: [
              'Total weight: 50kg',
              'Type of fire extinguishing bomb: Water - based'
            ]
          }
        ]
      },
      {
        title: "Rescue payload",
        list: [
          {
            name: 'Airborne loudspeaker',
            url: '/static/images/v2/600h/600h_logo7.png',
            url_load: '/static/images/v2/600h/600h_load7.png',
            info: [
              'Amplification power: 200w',
              'Function: Long - distance directional shouting'
            ]
          },
          {
            name: 'Airborne rescue cabin',
            url: '/static/images/v2/600h/600h_logo8.png',
            url_load: '/static/images/v2/600h/600h_load8.png',
            info: [
              'Maximum load - bearing capacity: 250kg',
              'Specifications: 1500*1000*1000mm'
            ]
          },
          {
            name: 'Airborne lighting',
            url: '/static/images/v2/600h/600h_logo9.png',
            url_load: '/static/images/v2/600h/600h_load9.png',
            info: [
              'Control method: Remote - control the lighting direction and brightness',
              'Lighting time: 2h'
            ]
          }
        ]
      },
      {
        title: "Hanging load",
        list: [
          {
            name: 'Airborne thrower',
            url: '/static/images/v2/600h/600h_logo10.png',
            url_load: '/static/images/v2/600h/600h_load10.png',
            info: [
              'Throwing weight: 200kg',
              'Number of hanging points: 10',
              'Safety strategy: Automatic throwing in abnormal conditions'
            ]
          },
          {
            name: 'Material transportation box',
            url: '/static/images/v2/600h/600h_logo11.png',
            url_load: '/static/images/v2/600h/600h_load11.png',
            info: [
              'Maximum load - bearing capacity: 100kg'
            ]
          },
          {
            name: 'Electric winch',
            url: '/static/images/v2/600h/600h_logo12.png',
            url_load: '/static/images/v2/600h/600h_load12.png',
            info: [
              'Load - bearing capacity: 100kg/150kg/200kg',
              'Rope length: 30m/50m',
              'Lifting speed: 0.25 - 0.4m/s'
            ]
          }
        ]
      }
    ],
    paramsList: [
      {
        title: "Power source",
        info:'oil-electric hybrid'
      }, {
        title: "Body size",
        info:'3.38*1.51m'
      },{
        title: "Cruising speed",
        info:'90km/h'
      },{
        title: "Maximum speed",
        info:'150km/h'
      },{
        title: "Maximum takeoff weight",
        info:'650kg'
      },{
        title: "Load capacity",
        info:'300kg'
      },{
        title: "Wind resistance",
        info:'15m/s'
      },{
        title: "Maximum flight altitude",
        info:'6000m'
      },{
        title: "Maximum takeoff altitude",
        info:'5000m'
      },{
        title: "Measurement and control radius",
        info:'100km'
      },{
        title: "Battery life",
        info:'210min'
      },{
        title: "Transport box size",
        info:'1.35*0.60*0.45m'
      },{
        title: "Positioning and navigation",
        info:'BDS, GPS, Galileo, Glonass'
      },{
        title: "GNSS Denial Environment",
        info:'Supports safe flight and visual navigation to track targets'
      },
    ]

  },
  hw25h:{
    text1:"Compound - wing UAV",
    text2:'Payload capacity',
    text3:'Endurance',
    text4:'HW-25H adopts a gasoline-electric hybrid drive mode, with a load capacity of 10kg and a battery life of 2 hours. It can be matched with a variety of loads. The unmanned helicopter is small in size, light in weight, flexible in mobility, and can complete tasks such as surveying, mapping, and reconnaissance in complex environments',
    text5:'Parameters',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'Hover',
        info:'The HW-25H can accurately maintain a fixed position and altitude in the air, making it convenient for fixed-point inspection, reconnaissance, and other operations'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:' Low-speed cruising',
        info:'With a cruising speed of 55km/h, low-speed cruising allows for detailed observation and operation in specific areas to better complete tasks.'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'Flexibility',
        info:'Small in size and light in weight, it can adjust its flight attitude quickly, allowing it to quickly change its flight direction, altitude, and speed.'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'High security',
        info:'Proprietary sensors + closed-loop attitude algorithm to maintain safe flight in denial environments where satellite signals are disturbed or tricked'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'Easy to transport',
        info:'Its compact fuselage and light weight make transportation convenient and can be transported to mission locations in a variety of ways'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'Can carry a variety of loads',
        info:'According to different mission requirements, it can carry a variety of payloads such as photoelectric pods and lidar to achieve operational tasks'
      },
    ],
    paramsList: [
      {
        title: "Power source",
        info:' oil-electric hybrid'
      }, {
        title: "Body size",
        info:'1.5*0.73m'
      },{
        title: "Cruising speed",
        info:'55km/h'
      },{
        title: "Maximum speed",
        info:'90km/h'
      },{
        title: "Maximum takeoff weight",
        info:'35kg'
      },{
        title: "Load capacity",
        info:'10kg'
      },{
        title: "Wind resistance",
        info:'15m/s'
      },{
        title: "Maximum flight altitude",
        info:'6500m'
      },{
        title: "Maximum takeoff altitude",
        info:'5000m'
      },{
        title: "Measurement and control radius",
        info:'50km'
      },{
        title: "Battery life",
        info:'120min'
      },{
        title: "Positioning and navigation",
        info:'BDS、GPS、Galileo、Glonass '
      },{
        title: "GNSS Denial Environment",
        info:'Supports full flight, supports visual navigation to track targets'
      },
    ]
  },
  zt120v:{
    text1:'Oil-electric hybrid vertical takeoff and landing fixed-wing UAV/drone',
    text2:'Payload capacity',
    text3:'Endurance',
    text4:'Extendable control range',
    text5:'ZT-120V UAS is an industry-leading product specially developed for aviation emergency rescue scenarios. It adopts a composite wing layout combining fixed wing and multi-rotor. The UAS is suitable for a full set of emergency - scene loads and can quickly complete aerial reconnaissance and communication support work. It has all-weather 3D modeling and rapid mapping capabilities, providing strong support and guarantee for emergency rescue work.',
    text6:'Airworthiness certification',
    text7:'On May 20, 2024, Yuandu Technology\'s ZT-120V drone system received the special airworthiness certificate for UAS  issued by the Civil Aviation Administration of China, becoming the first medium-sized composite-wing drone to receive a special airworthiness certificate',
    text8:'mission load',
    text9:'Parameters',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'Quadrotor + fixed-wing composite aerodynamic layout. It combines the convenience of vertical takeoff and landing with the long - endurance characteristic of fixed - wing, boasting a battery life of 10 hours'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'Modular design',
        info:'The fuselage, wings, and mission loads are all modular designs, which can be disassembled and assembled "without tools", allowing for quick assembly and deployment.'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'Ad hoc network data link',
        info:'Standard 50-100km ad hoc network data link, drone supports "UAS-UAS relay" technology, and the transmission distance can be extended to 300km +.'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'Anti-countermeasure and anti-interference',
        info:'Proprietary sensors and closed-loop attitude algorithms enable safe flight in an environment where satellite signals are disturbed or deceived.'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'Triple redundancy safety flight control',
        info:'The flight control system adopts a three-redundant design, with three sets of sensors that are independent of each other. The three sets of sensors support arbitration decisions and serve as backups for each other.'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'Multi-scene load capacity',
        info:'With a load capacity of 40kg, it can carry a variety of loads such as photoelectric pods and lidar, enabling multi-field and multi-scene applications.'
      },
    ],
    loadList:[{
      name:'Electro - optical Pod',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    },{
      name:'LIDAR',
      url:'/static/images/v2/120v/120v_load_jgld.png'
    },{
      name:'Fast 3D Modeling Payload',
      url:'/static/images/v2/120v/120v_load_swjm.png'
    },{
      name:'PDT',
      url:'/static/images/v2/120v/120v_load_pdt.png'
    },{
      name:'Airborne personnel search and rescue payload',
      url:'/static/images/v2/120v/120v_load_sjzh.png'
    },{
      name:'Airborne broadband ad hoc network equipment',
      url:'/static/images/v2/120v/120v_load_zzw.png'
    },{
      name:'Airborne satellite communication equipment',
      url:'/static/images/v2/120v/120v_load_jzwt.png'
    },{
      name:'Airborne public network base station',
      url:'/static/images/v2/120v/120v_load_gwjz.png'
    },],
    paramsList: [
      {
        title: "Power source",
        info:'oil-electric hybrid'
      }, {
        title: "Body size",
        info:'6.50*3.26m'
      },{
        title: "Cruising speed",
        info:'100km/h'
      },{
        title: "Maximum speed",
        info:'150km/h'
      },{
        title: "Maximum takeoff weight",
        info:'150kg'
      },{
        title: "Load capacity",
        info:'40kg'
      },{
        title: "Wind resistance",
        info:'15m/s'
      },{
        title: "Maximum flight altitude",
        info:'5500m'
      },{
        title: "Maximum takeoff altitude",
        info:'3500m'
      },{
        title: "Measurement and control radius",
        info:'100+km'
      },{
        title: "Battery life",
        info:'600min'
      },{
        title: "Shipping box size",
        info:'2.34*1.44*1.37m'
      },{
        title: "Positioning and navigation",
        info:'BDS、GPS、Galileo、Glonass '
      },{
        title: "GNSS Denial Environment",
        info:'Supports fixed-wing safe flight and visual navigation to track targets'
      },
    ]
  },
  zt60vs:{
    text1:'Oil-electric hybrid vertical takeoff and landing fixed-wing UAV/drone',
    text2:'Payload capacity',
    text3:'Endurance',
    text4:'Extendable control range',
    text5:'The ZT-60VS adopts a gasoline-electric hybrid  mode, with a load capacity of 15kg and a battery life of up to 10 hours. It can be matched with a variety of loads, with strong applicability. It is equipped with triple - redundancy safety flight control, which can effectively ensure flight safety',
    text6:'mission load',
    text7:'Parameters',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'Quadrotor + fixed-wing composite aerodynamic layout. “It combines the convenience of vertical takeoff and landing with the long - endurance characteristic of fixed - wing, boasting a battery life of 10 hours'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'Modular design',
        info:'The fuselage, wings, and mission loads are all modular designs, which can be disassembled and assembled "without tools", allowing for quick assembly and deployment.'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'Ad hoc network data link',
        info:'Standard 50-100km ad hoc network data link, drone supports "UAS-UAS relay" technology, and the transmission distance can be extended to 300km +.'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'Anti-countermeasure and anti-interference',
        info:'Proprietary sensors and closed-loop attitude algorithms enable safe flight in an environment where satellite signals are disturbed or deceived.'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'Triple redundancy safety flight control',
        info:'The flight control system adopts a three-redundant design, with three sets of sensors that are independent of each other. The three sets of sensors support arbitration decisions and serve as backups for each other.'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'Multi-scene load capacity',
        info:'With a load capacity of 15kg, it can carry a variety of loads such as photoelectric pods and lidar, enabling multi-field and multi-scene applications.'
      },
    ],
    loadList:[{
      name:'Electro - optical Pod',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    }
      ,{
        name:'orthophoto camera',
        url:'/static/images/v2/60vs/60vs_load_zsxj.png'
      },{
        name:'Fast 3D Modeling Payload',
        url:'/static/images/v2/120v/120v_load_swjm.png'
      },{
        name:'LIDAR',
        url:'/static/images/v2/120v/120v_load_jgld.png'
      }],
    paramsList: [
      {
        title: "Power source",
        info:'oil-electric hybrid'
      }, {
        title: "Body size",
        info:'4.80*2.65m'
      },{
        title: "Cruising speed",
        info:'90km/h'
      },{
        title: "Maximum speed",
        info:'130km/h'
      },{
        title: "Maximum takeoff weight",
        info:'78kg'
      },{
        title: "Load capacity",
        info:'15kg'
      },{
        title: "Wind resistance",
        info:'15m/s'
      },{
        title: "Maximum flight altitude",
        info:'5500m'
      },{
        title: "Maximum takeoff altitude",
        info:'3500m'
      },{
        title: "Measurement and control radius",
        info:'100+km'
      },{
        title: "Battery life",
        info:'600min'
      },{
        title: "Transport box size",
        info:'1.85*0.47*1.15m \n' +
          '1.85*1.03*0.76m'
      },{
        title: "Positioning and navigation",
        info:'BDS、GPS、Galileo、Glonass '
      },{
        title: "GNSS Denial Environment",
        info:'Supports fixed-wing safe flight and visual navigation to track targets'
      },
    ]
  },
  zt60v:{
    text1:"Compound - wing UAV",
    text2:'Payload capacity',
    text3:'Endurance',
    text4:'ZT-60V adopts pure electric mode, load capacity 15kg, battery life up to 4 hours, combines convenience, timeliness, low cost in one，with an outstanding general capabilities',
    text5:'mission load',
    text6:'Parameters',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'Four-rotor + fixed-wing composite aerodynamic layout, wind resistance of 15m/s, practical ceiling of 7000m'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'Modular design',
        info:'The fuselage, wings, and mission loads are all modular designs, which can be disassembled and assembled "without tools", allowing for quick assembly and deployment.'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'Mobile platform take-off and landing + remote take-off and landing',
        info:'Built-in anti-interference sensors support takeoff and landing in non-stationary conditions such as high-speed movement or complex sea conditions, and can support off-site takeoff and landing over 100km.'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'Anti-countermeasure and anti-interference',
        info:'Proprietary sensors and closed-loop attitude algorithms enable safe flight in an environment where satellite signals are disturbed or deceived.'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'Triple redundancy safety flight control',
        info:'The flight control system adopts a three-redundant design, with three sets of sensors that are independent of each other. The three sets of sensors support arbitration decisions and serve as backups for each other.'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'Multi-scene load capacity',
        info:'With a load capacity of 15kg, it can carry a variety of loads such as photoelectric pods and lidar, enabling multi-field and multi-scene applications.'
      },
    ],
    loadList:[{
      name:'Electro - optical Pod',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    }
      ,{
        name:'orthophoto camera',
        url:'/static/images/v2/60vs/60vs_load_zsxj.png'
      },{
        name:'Fast 3D Modeling Payload',
        url:'/static/images/v2/120v/120v_load_swjm.png'
      },{
        name:'LIDAR',
        url:'/static/images/v2/120v/120v_load_jgld.png'
      }],
    paramsList: [
      {
        title: "Power source",
        info:'Long endurance battery'
      }, {
        title: "Body size",
        info:'4.80*2.65m'
      },{
        title: "Cruising speed",
        info:'85km/h'
      },{
        title: "Maximum speed",
        info:'130km/h'
      },{
        title: "Maximum takeoff weight",
        info:'68kg'
      },{
        title: "Load capacity",
        info:'15kg'
      },{
        title: "Wind resistance",
        info:'15m/s'
      },{
        title: "Maximum flight altitude",
        info:'6500m'
      },{
        title: "Maximum takeoff altitude",
        info:'5000m'
      },{
        title: "Measurement and control radius",
        info:'50+km'
      },{
        title: "Battery life",
        info:'240min'
      },{
        title: "Transport box size",
        info:'1.85*0.47*1.15m \n' +
          '1.85*1.03*0.76m'
      },{
        title: "Positioning and navigation",
        info:'BDS、GPS、Galileo、Glonass '
      },{
        title: "GNSS Denial Environment",
        info:'Supports fixed-wing safe flight and visual navigation to track targets'
      },
    ]
  },
  zt25vs:{
    text1:"Compound - wing UAV",
    text2:'Payload capacity',
    text3:'Endurance',
    text4:'Extendable control range',
    text5:' ZT-25VS adopts four-rotor and fixed-wing composite aerodynamic layout and oil-electric hybrid drive mode, with a load capacity of 8kg and a battery life of 12 hours, which can meet the needs of long-term operation',
    text6:'Parameters',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'Quadrotor + fixed-wing composite aerodynamic layout. It has both the convenience of vertical takeoff and landing, and the characteristics of fixed-wing long endurance, with a battery life of 12 hours'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'Modular design',
        info:'The fuselage, wings, and mission loads are all modular designs, which can be disassembled and assembled "without tools", allowing for quick assembly and deployment.'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'Ad hoc network data link',
        info:'Standard 50-100km ad hoc network data link, drone supports "UAS-UAS relay" technology, and the transmission distance can be extended to 300km +.'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'Anti-countermeasure and anti-interference',
        info:'Proprietary sensors and closed-loop attitude algorithms enable safe flight in an environment where satellite signals are disturbed or deceived.'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'Triple redundancy safety flight control',
        info:'The flight control system adopts a three-redundant design, with three sets of sensors that are independent of each other. The three sets of sensors support arbitration decisions and serve as backups for each other.'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'Multi-scene load capacity',
        info:'With a load capacity of 8kg, it can carry a variety of loads such as photoelectric pods and lidar, enabling multi-field and multi-scene applications.'
      },
    ],
    paramsList: [
      {
        title: "Power source",
        info:'oil-electric hybrid'
      }, {
        title: "Body size",
        info:'4.00*2.06m'
      },{
        title: "Cruising speed",
        info:'85km/h'
      },{
        title: "Maximum speed",
        info:'130km/h'
      },{
        title: "Maximum takeoff weight",
        info:'40kg'
      },{
        title: "Load capacity",
        info:'8kg'
      },{
        title: "Wind resistance",
        info:'15m/s'
      },{
        title: "Maximum flight altitude",
        info:'5500m'
      },{
        title: "Maximum takeoff altitude",
        info:'3500m'
      },{
        title: "Measurement and control radius",
        info:'100+km'
      },{
        title: "Battery life",
        info:'720min'
      },{
        title: "Transport box size",
        info:'1.56*0.63*0.82m'
      },{
        title: "Positioning and navigation",
        info:'BDS、GPS、Galileo、Glonass '
      },{
        title: "GNSS Denial Environment",
        info:'Supports fixed-wing safe flight and visual navigation to track targets'
      },
    ]
  },
  zt25v:{
    text1:"Compound - wing UAV",
    text2:'Payload capacity',
    text3:'Endurance',
    text4:' ZT-25V adopts pure electric drive mode, with a load capacity of 10kg and a battery life of up to 4 hours. It has significant advantages in timeliness, convenience, economy and safety',
    text5:'mission load',
    text6:'Parameters',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'Quad rotor + fixed wing composite aerodynamic layout, using pure electric drive, low cost of economy and environmental protection.'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'Modular design',
        info:'The fuselage, wings, and mission loads are all modular designs, which can be disassembled and assembled "without tools", allowing for quick assembly and deployment.'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:' Mobile platform take-off and landing + remote take-off and landing',
        info:'Built-in anti-interference sensors support takeoff and landing in non-stationary conditions such as high-speed movement or complex sea conditions, and can support off-site takeoff and landing over 100km.'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'Anti-countermeasure and anti-interference',
        info:'Proprietary sensors and closed-loop attitude algorithms enable safe flight in an environment where satellite signals are disturbed or deceived.'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'Triple redundancy safety flight control',
        info:'The flight control system adopts a three-redundant design, with three sets of sensors that are independent of each other. The three sets of sensors support arbitration decisions and serve as backups for each other.'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'Multi-scene load capacity',
        info:'With a load capacity of 10kg, it can carry a variety of loads such as photoelectric pods and lidar, enabling multi-field and multi-scene applications'
      },
    ],
    loadList:[{
      name:'Electro - optical Pod',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    }
      ,{
        name:'orthophoto camera',
        url:'/static/images/v2/60vs/60vs_load_zsxj.png'
      },{
        name:'Fast 3D Modeling Payload',
        url:'/static/images/v2/120v/120v_load_swjm.png'
      },{
        name:'LIDAR',
        url:'/static/images/v2/120v/120v_load_jgld.png'
      },{
        name:'megaphone',
        url:'/static/images/v2/25v/25v_load_hhq.png'
      }],
    paramsList: [
      {
        title: "Power source",
        info:'smart battery/long endurance battery'
      }, {
        title: "Body size",
        info:'4.13*1.93m'
      },{
        title: "Cruising speed",
        info:'72km/h'
      },{
        title: "Maximum speed",
        info:'130km/h'
      },{
        title: "Maximum takeoff weight",
        info:'38kg'
      },{
        title: "Load capacity",
        info:'10kg'
      },{
        title: "Wind resistance",
        info:'15m/s'
      },{
        title: "Maximum flight altitude",
        info:'6500m'
      },{
        title: "Maximum takeoff altitude",
        info:'5000m'
      },{
        title: "Measurement and control radius",
        info:'50+km'
      },{
        title: "Battery life",
        info:'240min'
      },{
        title: "Transport box size",
        info:'1.56*0.63*0.82m'
      },{
        title: "Positioning and navigation",
        info:'BDS、GPS、Galileo、Glonass '
      },{
        title: "GNSS Denial Environment",
        info:'Supports fixed-wing safe flight and visual navigation to track targets'
      },
    ]
  },
  zt16v:{
    text1:"Compound - wing UAV",
    text2:'Payload capacity',
    text3:'Endurance',
    text4:' ZT-16V adopts pure electric drive mode, with a load capacity of 4kg and a battery life of 3 hours. The overall fuselage adopts a modular design, which can be quickly assembled to perform tasks',
    text5:'mission load',
    text6:'Parameters',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'Quad rotor + fixed wing composite aerodynamic layout, using pure electric drive, low cost of economy and environmental protection.'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'Modular design',
        info:'The fuselage, wings, and mission loads are all modular designs, which can be disassembled and assembled "without tools", allowing for quick assembly and deployment.'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'Ad hoc network data link',
        info:'Standard 50-100km ad hoc network data link, drone supports "UAS-UAS relay" technology, and the transmission distance can be extended to 300km +.'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'Anti-countermeasure and anti-interference',
        info:'Proprietary sensors and closed-loop attitude algorithms enable safe flight in an environment where satellite signals are disturbed or deceived.'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'Triple redundancy safety flight control',
        info:'The flight control system adopts a three-redundant design, with three sets of sensors that are independent of each other. The three sets of sensors support arbitration decisions and serve as backups for each other.'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'Mobile platform take-off and landing + off-site take-off and landing',
        info:'Built-in anti-interference sensors support takeoff and landing in non-stationary conditions such as high-speed movement or complex sea conditions, and can support off-site takeoff and landing over 100km.'
      },
    ],
    loadList:[{
      name:'Electro - optical Pod',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    }
      ,{
        name:'orthophoto camera',
        url:'/static/images/v2/60vs/60vs_load_zsxj.png'
      },{
        name:'Fast 3D Modeling Payload',
        url:'/static/images/v2/120v/120v_load_swjm.png'
      },{
        name:'LIDAR',
        url:'/static/images/v2/120v/120v_load_jgld.png'
      }],
    paramsList: [
      {
        title: "Power source",
        info:'smart battery'
      }, {
        title: "Body size",
        info:'3.38*1.57m'
      },{
        title: "Cruising speed",
        info:'55km/h'
      },{
        title: "Maximum speed",
        info:'120km/h'
      },{
        title: "Maximum takeoff weight",
        info:'20kg'
      },{
        title: "Load capacity",
        info:'4kg'
      },{
        title: "Wind resistance",
        info:'13m/s'
      },{
        title: "Maximum flight altitude",
        info:'6500m'
      },{
        title: "Maximum takeoff altitude",
        info:'4500m'
      },{
        title: "Measurement and control radius",
        info:'50+km'
      },{
        title: "Battery life",
        info:'180min'
      },{
        title: "Transport box size",
        info:'1.35*0.60*0.45m'
      },{
        title: "Positioning and navigation",
        info:'BDS、GPS、Galileo、Glonass '
      },{
        title: "GNSS Denial Environment",
        info:'Supports fixed-wing safe flight and visual navigation to track targets'
      },
    ]
  },
  zt13v:{
    text1:"Compound - wing UAV",
    text2:'Payload capacity',
    text3:'Endurance',
    text4:'  ZT-13V adopts pure electric drive mode, with a load capacity of 3kg, a battery life of 200 minutes, and a maximum range of 180km. It is a drone specially suitable for unmanned airports',
    text5:'Parameters',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'Quad rotor + fixed wing composite aerodynamic layout, using pure electric drive, low cost of economy and environmental protection.'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'Modular design',
        info:'The fuselage, wings, and mission loads are all modular designs, which can be disassembled and assembled "without tools", allowing for quick assembly and deployment.'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'Ad hoc network data link',
        info:'Standard 50-100km ad hoc network data link, drone supports "UAS-UAS relay" technology, and the transmission distance can be extended to 300km +.'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'Anti-countermeasure and anti-interference',
        info:'Proprietary sensors and closed-loop attitude algorithms enable safe flight in an environment where satellite signals are disturbed or deceived.'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'Triple redundancy safety flight control',
        info:'The flight control system adopts a three-redundant design, with three sets of sensors that are independent of each other. The three sets of sensors support arbitration decisions and serve as backups for each other.'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'Mobile platform take-off and landing + off-site take-off and landing',
        info:'Built-in anti-interference sensors support takeoff and landing in non-stationary conditions such as high-speed movement or complex sea conditions, and can support off-site takeoff and landing over 100km.'
      },
    ],
    paramsList: [
      {
        title: "Power source",
        info:'smart battery'
      }, {
        title: "Body size",
        info:'3.00*1.77m'
      },{
        title: "Cruising speed",
        info:'55km/h'
      },{
        title: "Maximum speed",
        info:'100km/h'
      },{
        title: "Maximum takeoff weight",
        info:'18kg'
      },{
        title: "Load capacity",
        info:'3kg'
      },{
        title: "Wind resistance",
        info:'8m/s'
      },{
        title: "Maximum flight altitude",
        info:'5000m'
      },{
        title: "Maximum takeoff altitude",
        info:'3000m'
      },{
        title: "Measurement and control radius",
        info:'50+km'
      },{
        title: "Battery life",
        info:'200min'
      },{
        title: "Positioning and navigation",
        info:'BDS、GPS、Galileo、Glonass '
      },{
        title: "GNSS Denial Environment",
        info:'Supports fixed-wing safe flight and visual navigation to track targets'
      },
    ]
  },
  gddc:{
    "text1": "Product Center_Mission Payload_Electro-optical Pod",
    "list": [
      {
        "type": 0,
        "title": "GD3035",
        "name": "Dual light pod",
        "info": [
          "Pod weight: ≤ 800g",
          "Pod size: H173mm * φ 122mm",
          "Mechanical stabilization: three-axis mechanical stabilization",
          "Pitch range: + 45 °~ -135 °",
          "Heading range: 360 ° * N",
          "Roll range：±60°",
          "Visible light camera: 30x optical zoom",
          "Infrared camera：Uncooled infrared",
          "Positioning accuracy：30m@1000m（CEP）"
        ],
        "position": 0,
        "urls": [
          "/static/images/v2/gddc/GD3035_1.png",
          "/static/images/v2/gddc/GD3035_2.png",
          "/static/images/v2/gddc/GD3035_3.png",
          "/static/images/v2/gddc/GD3035_4.png"
        ],
        "bg": "/static/images/v2/gddc/gddc_bg1.png"
      },
      {
        "type": 1,
        "title": "GT3035L",
        "name": "Tri-light Pod",
        "info": [
          "Pod weight：≤1000g",
          "Pod size：H173mmφ122mm",
          "Mechanical stabilization: three-axis mechanical stabilization",
          "Pitch range：+25°～-135°",
          "Heading range：360°N",
          "Roll range：±60°",
          "Visible light camera: 30x optical zoom",
          "Infrared camera：Uncooled infrared",
          "Laser ranging：20～3000m laser ranging",
          "Positioning accuracy：30m@1000m（CEP）"
        ],
        "position": 0,
        "urls": [
          "/static/images/v2/gddc/GT3035L_1.png",
          "/static/images/v2/gddc/GT3035L_2.png",
          "/static/images/v2/gddc/GT3035L_3.png",
          "/static/images/v2/gddc/GT3035L_4.png"
        ],
        "bg": "/static/images/v2/gddc/gddc_bg2.png"
      },
      // {
      //   "type": 1,
      //   "title": "PT4075L",
      //   "name": "40X Tri-light Pod",
      //   "info": [
      //     "Pod weight：≤4kg",
      //     "Pod size：H282mmφ190mm",
      //     "Mechanical stabilization: three-axis mechanical stabilization",
      //     "Pitch range：+45°～-135°",
      //     "Heading range: 360 ° * N",
      //     "Roll range：±48°",
      //     "Visible light camera: 40x optical zoom",
      //     "Infrared camera：Uncooled infrared",
      //     "Laser ranging：50～6000m laser ranging",
      //     "Positioning accuracy：30m@1000m"
      //   ],
      //   "position": 0,
      //   "urls": [
      //     "/static/images/v2/gddc/PT4075L_1.png",
      //     "/static/images/v2/gddc/PT4075L_2.png"
      //   ],
      //   "bg": "/static/images/v2/gddc/gddc_bg8.png"
      // },
      {
        "type": 1,
        "title": "PD3035/PD30351",
        "name": "High-precision Dual-light Pod",
        "info": [
          "Pod weight：≤1.6kg",
          "Pod size：H200mm*φ135mm",
          "Mechanical stabilization: three-axis mechanical stabilization",
          "Pitch range：+45°～-135°",
          "Heading range: 360 ° * N",
          "Roll range：±60°",
          "Visible light camera: 30x optical zoom",
          "Infrared camera：Uncooled infrared",
          "Infrared focal length：35mm",
          "Positioning accuracy：30m@1000m（PT3035L）/3m@1000m（PT3035IL）",
          "AI/AR：Supports the recognition of people, vehicles, ships, and animals; supports AR information overlay"
        ],
        "position": 0,
        "urls": [
          "/static/images/v2/gddc/PD30351_1.png",
          "/static/images/v2/gddc/PD30351_2.png"
        ],
        "bg": "/static/images/v2/gddc/gddc_bg5.png"
      },
      {
        "type": 1,
        "title": "PT3035L/PT3035IL",
        "name": "Tri-light Pod/High-precision Tri-light Pod",
        "info": [
          "Pod weight：≤1.6kg",
          "Pod size：H200mmφ135mm",
          "Mechanical stabilization: three-axis mechanical stabilization",
          "Pitch range：+45°～-135°",
          "Heading range: 360 ° * N",
          "Roll range：±60°",
          "Visible light camera: 30x optical zoom",
          "Infrared camera：Uncooled infrared",
          "Laser ranging：20～3000m laser ranging",
          "Positioning accuracy：30m@1000m（PT3035L） /3m@1000m（PT3035IL）"
        ],
        "position": 0,
        "urls": [
          "/static/images/v2/gddc/PT3035LPT3035IL_2.png",
          "/static/images/v2/gddc/PT3035LPT3035IL_1.png",
          "/static/images/v2/gddc/PT3035LPT3035IL_3.png",
          "/static/images/v2/gddc/PT3035LPT3035IL_4.png"
        ],
        "bg": "/static/images/v2/gddc/gddc_bg3.png"
      },
      {
        "type": 0,
        "title": "PT3075L/PT3075IL",
        "name": "Tri-light Pod/High-precision Tri-light Pod",
        "info": [
          "Pod weight：≤3kg",
          "Pod size：H272mmφ180mm",
          "Mechanical stabilization: three-axis mechanical stabilization",
          "Pitch range：+45°～-105°",
          "Heading range: 360 ° * N",
          "Roll range：±45°",
          "Visible light camera: 30x optical zoom",
          "Infrared camera：Uncooled infrared",
          "Laser ranging：50～6000m laser ranging",
          "Positioning accuracy：30m@1000m（PT3075L） /3m@1000m（PT3075IL）"
        ],
        "position": 0,
        "urls": [
          "/static/images/v2/gddc/PT3075LPT3075IL_1.png",
          "/static/images/v2/gddc/PT3075LPT3075IL_2.png",
          "/static/images/v2/gddc/PT3075LPT3075IL_3.png",
          "/static/images/v2/gddc/PT3075LPT3075IL_4.png"
        ],
        "bg": "/static/images/v2/gddc/gddc_bg4.png"
      },
      {
        "type": 1,
        "title": "PD30275C",
        "name": "Zoom Cooled Infrared Dual-light Pod",
        "info": [
          "Pod weight：≤4kg",
          "Pod size：H290mmφ200mm",
          "Mechanical stabilization: three-axis mechanical stabilization",
          "Pitch range：+45°～-135°",
          "Heading range: 360 ° * N",
          "Roll range：±50°",
          "Visible light camera: 30x optical zoom",
          "Infrared camera：Zoom Cooled Infrared"
        ],
        "position": 0,
        "urls": [
          "/static/images/v2/gddc/PD30275C_1.png",
          "/static/images/v2/gddc/PD30275C_2.png"
        ],
        "bg": "/static/images/v2/gddc/gddc_bg5.png"
      },
      {
        "type": 1,
        "title": "PT30275CL",
        "name": "Zoom Cooled Infrared Tri-light Pod",
        "info": [
          "Pod weight：≤5kg",
          "Pod size：H290mmφ220mm",
          "Mechanical stabilization: three-axis mechanical stabilization",
          "Pitch range：+45°～-135°",
          "Heading range: 360 ° * N",
          "Roll range：±45°",
          "Visible light camera: 30x optical zoom",
          "Infrared camera：Zoom Cooled Infrared",
          "Laser ranging：6000m laser ranging",
          "Positioning accuracy：30m@1000m"
        ],
        "position": 0,
        "urls": [
          "/static/images/v2/gddc/PT30275CL_1.png",
          "/static/images/v2/gddc/PT30275CL_2.png"
        ],
        "bg": "/static/images/v2/gddc/gddc_bg6.png"
      },
      {
        "type": 1,
        "title": "PT3035LD",
        "name": "Laser Indication Tri-light Pod",
        "info": [
          "Pod weight：≤3kg",
          "Pod size：H265mmφ172mm",
          "Mechanical stabilization: three-axis mechanical stabilization",
          "Pitch range：+35°～-135°",
          "Heading range: 360 ° * N",
          "Roll range：±45°",
          "Visible light camera: 30x optical zoom",
          "Infrared camera：Uncooled infrared",
          "Laser ranging：150～10000m laser ranging",
          "Positioning accuracy：30m@1000m"
        ],
        "position": 0,
        "urls": [
          "/static/images/v2/gddc/PT3035LD_1.png",
          "/static/images/v2/gddc/PT3035LD_2.png"
        ],
        "bg": "/static/images/v2/gddc/gddc_bg7.png"
      },
    ]
  },
  chxj: {
    text1: 'Product Center_Mission Payload_Surveying Camera',
    list: [
      //
      {
        title:'125 million Pixel 5-lens tilt camera',
        name:'',
        url:'/static/images/v2/chxj/chxj_1.png',
        bg:'/static/images/v2/chxj/chxj_bg1.png',
        info:['Size：140*140*125mm','Weight：666g','Operating temperature：-20°C-65°C','Camera power supply: external power supply DC12-50V','Camera Interface: Universal Aerial Interface','Effective pixels: single lens is better than 25 million pixels, total > 125 million pixels','Sensor: Sensor size: 23.1 * 15.4mm','pixel size:3.76μm','Image size6144x4096 px','Lens focal length: Tilt 56mm, Orthopic 40mm','Storage capacity：1280GB','Photo interval：≥0.6s','Parameter adjustment: support IS0, white balance, color mode, shutter speed and other settings modification, support Bluetooth parameter tuning','Data speed: up to 600M/s ']
      },
      {
        title:'225 million pixel full frame size five-lens tilt camera',
        name:'',
        url:'/static/images/v2/chxj/chxj_2.png',
        bg:'/static/images/v2/chxj/chxj_bg2.png',
        info:['Size：182*203*196 mm','Weight：1280g','Operating temperature：-20°C-65°C','Camera power supply: external power supply DC12-50V','Camera Interface: Universal Aerial Interface','Effective pixels: single lens 45 million pixels, total 225 million pixels','Sensor: Sensor size: 36 * 24mm','pixel size:4.4μm','Image size8192*5456 px','Lens focal length: Tilt 56mm, Orthopic 40mm','Storage capacity：1280GB storage module * 2','Photo interval：≥0.9s','Parameter adjustment: support IS0, white balance, color mode, shutter speed and other settings modification, support Bluetooth parameter tuning','Data speed: up to 600M/s ','PTZ Angle: Pitch: -120 ° to + 45 °; Roll: ± 25 °; Translation: ± 160 °']
      },
      {
        title:'6100X',
        name:'Full frame size single lens aerial camera',
        url:'/static/images/v2/chxj/chxj_3.png',
        bg:'/static/images/v2/chxj/chxj_bg3.png',
        info:['Size：128*181*153 mm','Weight：640g','Operating temperature：-20°C-65°C','Camera power supply: external power supply DC12-50V','Camera Interface: Universal Aerial Interface','Effective pixels: 61 million pixels','Sensor: Sensor size: 36 * 24mm','pixel size:3.76μm','Image size9552x 6368 px','Lens focal length: standard 40mm, can be customized 56mm','Storage capacity：512GB','Photo interval：≥1s','Parameter adjustment: support IS0, white balance, color mode, shutter speed and other settings modification, support Bluetooth parameter tuning','Video specifications: 4K (3860 * 2610), 30 fps','Head Angle: Pitch: -130 ° to + 45 °; Roll: ± 55 °; Translation: ± 320 °']
      },
      {
        title:'100M PRO V2',
        name:'102 million pixel frame size Single lens aerial camera',
        url:'/static/images/v2/chxj/chxj_4.png',
        bg:'/static/images/v2/chxj/chxj_bg4.png',
        info:['Size：131*147*205mm','Weight：900g','Operating temperature：-20°C-65°C','Camera power supply: external power supply DC12-50V','Camera Interface: Universal Aerial Interface','Effective pixels: 102 million pixels','Sensor: IMX461, size 43.8 * 32.9mm,','pixel size:3.76μm','Image size11648*8736 px','Lens focal length: 50mm/70mm','Storage capacity：512GB×2','Photo interval：≥0.85S(JPG格式)','Parameter adjustment: support IS0, white balance, color mode, shutter speed and other settings modification, support Bluetooth parameter tuning','Video specifications: 4K (3860 * 2610), 30 fps','PTZ Angle: Pitch: -135 ° to + 60 °; Roll: -55 ° to 90 °; Translation: ± 160 °']
      }
    ],
  },
  jgld: {
    text1: 'Product Center_Mission Payload_Lidar',
    list: [
      //
      {
        title:'RD1000',
        name:'LIDAR',
        url:'/static/images/v2/jgld/jgld_1.png',
        bg:'/static/images/v2/jgld/jgld_bg1.png',
        info:['Weight：2.2kg','System accuracy: horizontal 5cm, vertical 5cm ','Storage capacity：256GB','Power consumption of the whole machine：70W','Maximum scanning distance：1000m','Maximum transmission frequency：100万点/秒','Maximum scanning angle：100°','Angular resolution：0.001°','Laser safety class：Class 1 (naked eye safety)','GNSS：Hold a single Beidou mode','Data update frequency：500Hz','Camera pixels：4500万','Camera focal length：18mm','Adaptation software: 3D visualization software, preprocessing/post-processing software']
      },
      {
        title:'RD1500',
        name:'LIDAR',
        url:'/static/images/v2/jgld/jgld_2.png',
        bg:'/static/images/v2/jgld/jgld_bg2.png',
        info:['Weight：3.9kg','System accuracy: horizontal 5cm, vertical 5cm ','Storage capacity：256GB','Power consumption of the whole machine：75W','Maximum scanning distance：1500m','Maximum transmission frequency：200万点/秒','Maximum scanning angle：75°','Angular resolution：0.00015°','Laser safety class：Class 1 (naked eye safety)','GNSS：Hold a single Beidou mode','Data update frequency：600Hz','Camera pixels：4500万','Camera focal length：18mm','Adaptation software: 3D visualization software, preprocessing/post-processing software']
      },
    ],
  },
  dmsb:{
    "text1": "Product Center_Ground Equipment",
    "text2": "ZT-T30 Portable Ground Station",
    "text3": "ZT-T30 is a ground mobile control endpoint that supports single-person handheld control of drones. The portable ground station highly integrates the ground station, data transfer, and pod touch display functions. It weighs 3kg and has a built-in battery with a working time of 4 hours. It effectively improves the control efficiency and user experience of the pilot.",
    "text4": "Parameters",
    "text5": "ZT-TG2 Dual-screen Control Station",
    "text6": "ZT-TG2 is a UAV ground control terminal featuring a folding dual-screen design. It can display video images, flight data, and the aircraft's flight route simultaneously. The dual-screen images can be switched at any time, greatly improving the UAV control efficiency.",
    "text7": "Parameters",
    "text8": "Roaming Data Link",
    "text9": "For fields such as long-distance patrols and urban patrols, Yuandu Technology has launched a drone roaming scheduling system. It innovatively adopts base station collaborative scheduling technology to collect base station signal quality, link status, packet loss rate and other information in real time and conduct comprehensive analysis, achieving fast and accurate dynamic scheduling and handover of base stations. The system has been successfully applied to UAS urban roaming patrol projects, creating low-latency, stable and reliable communication links for multiple drones. It can adapt to complex environments and provide a solid communication guarantee for industrial applications.",
    "text10": "Relay Data Link",
    "text11": "The UAS relay communication system innovates with intelligent signal optimization technology, collecting key signal information in real time and conducting in-depth analysis, accurately enhancing and optimizing the signal. It builds a stable and efficient data link for the UAS and ensures communication over a distance of 50-100 kilometers or even longer. In complex environments such as cities with high-rise buildings and mountainous areas with changeable terrain, the system can avoid interference and occlusion to ensure smooth signal transmission. The system allows operators to free their hands, achieve multi-task collaboration, greatly improving operation efficiency, and providing a solid guarantee for the stable operation and efficient operation of various drones. Currently, the system has been successfully applied to application scenarios such as power inspection and mountain surveying and mapping.",
    "padList": [
      {
        "name": "Lightweight and Easy to Carry",
        "text": "The portable ground station weighs only 3kg, is controlled by the pilot, and is lightweight and easy to carry.\n"
      },
      {
        "name": "Full-featured",
        "text": "Supports a variety of task design modes, with comprehensive functions and easy to use."
      },
      {
        "name": "Long-lasting Battery Life",
        "text": "The built-in battery lasts for more than 4 hours, with a long battery life, ensuring worry-free tasks."
      },
      {
        "name": "High-resolution Video",
        "text": "Supports 1920 × 1080 high-resolution video, with a clear and smooth picture."
      },
      {
        "name": "Real-time Live Broadcast",
        "text": "The drone video screen can be broadcast live in real time and viewed anytime, anywhere.\n"
      }
    ],
    "pcList": [
      {
        "name": "Dual Screen",
        "text": "Adopts dual-screen high-definition display, greatly improving UAV control efficiency."
      },
      {
        "name": "Folding Design",
        "text": "The box has a folding design, making it easy to transport and operate."
      },
      {
        "name": "Full-featured",
        "text": "Supports a variety of task design modes, with comprehensive functions and easy for beginners."
      },
      {
        "name": "Powerful Performance",
        "text": "32GB RAM + 1T storage space, with powerful performance."
      },
      {
        "name": "Long-lasting Battery Life",
        "text": "The built-in battery lasts for more than 4 hours, with a long battery life, ensuring worry-free tasks."
      },
      {
        "name": "High-resolution Video",
        "text": "Supports 1920 × 1080 high-resolution video, with a clear and smooth picture."
      },
      {
        "name": "Real-time Live Broadcast",
        "text": "The drone video screen can be broadcast live in real time and viewed anytime, anywhere."
      }
    ],
    "padParams": [
      {
        "name": "Size",
        "text": "340195105mm\n" +
          "（±5mm）(length * width * height)"
      },
      {
        "name": "Screen Size",
        "text": "10.1 inches"
      },
      {
        "name": "Screen Resolution",
        "text": "1920 * 1200"
      },
      {
        "name": "Charging Power Supply",
        "text": "（20V/3.25A）65W"
      },
      {
        "name": "Charging Power Supply",
        "text": "Single-phase 220V±10%/50Hz"
      },
      {
        "name": "Weight",
        "text": "≤3kg"
      },
      {
        "name": "Battery Life",
        "text": "≥4 hours"
      },
      {
        "name": "Memory",
        "text": "8GB"
      },
      {
        "name": "Storage",
        "text": "64GB"
      }
    ],
    "pcParams": [
      {
        "name": "Size",
        "text": "413330100mm"
      },
      {
        "name": "Screen Size",
        "text": "15.6 inches * 2"
      },
      {
        "name": "Screen Resolution",
        "text": "1920 * 1200"
      },
      {
        "name": "Keyboard",
        "text": "86 keys + shortcut keys + trackpad + joystick"
      },
      {
        "name": "Charging Power Supply",
        "text": "Single-phase 220V ± 10%/50Hz"
      },
      {
        "name": "Weight",
        "text": "≤10kg (overall weight)"
      },
      {
        "name": "Battery Life",
        "text": "≥4 hours"
      },
      {
        "name": "Memory",
        "text": "32GB"
      },
      {
        "name": "Storage",
        "text": "1T"
      }
    ],
    "meshList": [
      {
        "title": "Electric Drone Ground Relay Station",
        "name": "RSM02",
        "position": 0,
        "urls": [
          "/static/images/v2/dmsb/rsm02_1.png",
          "/static/images/v2/dmsb/rsm02_2.png"
        ],
        "text": " \n" +
          "Transmit Power: Dual channel 2 * 2W\n" +
          "Working Frequency Band: L-band, 135MHz~ 1450MHz\n" +
          "Channel Bandwidth: 1/5/10/20MHz (optional)\n" +
          "Networking Function: 3 hops and 8 nodes\n" +
          "Communication Distance: 65km (50 + km)"
      },
      {
        "title": "Hybrid Drone Ground Relay Station",
        "name": "RSM10",
        "position": 0,
        "urls": [
          "/static/images/v2/dmsb/rsm10_1.png",
          "/static/images/v2/dmsb/rsm10_2.png"
        ],
        "text": " \n" + "Transmit Power: Dual channel 2 * 10W\n" +
          "Working Frequency Band: L-band, 135MHz~ 1450MHz\n" +
          "Channel Bandwidth: 1/5/10/20MHz (optional)\n" +
          "Communication Distance: 120km (100 + km)"
      },
      {
        "title": "Tracking Antenna Relay Ground Station",
        "name": "TAM10",
        "position": 0,
        "urls": [
          "/static/images/v2/dmsb/tam10_1.png",
          "/static/images/v2/dmsb/tam10_2.png",
          "/static/images/v2/dmsb/tam10_3.png"
        ],
        "text": " \n" + "Transmit Power: Dual channel 2 * 10W\n" +
          "Working Frequency Band: L-band, 135MHz~ 1450MHz\n" +
          "Channel Bandwidth: 1/5/10/20MHz (optional)\n" +
          "Networking Function: 3 hops and 8 nodes\n" +
          "Communication Distance: 200km"
      }
    ]
  },
  rjcp:{
    text1:'Product Center_Software Products',
    list: [
      //
      {
        title: 'Inspection Assistant',
        name: '',
        url: '/static/images/v2/rjcp/rj_img1.png',
        bg: '/static/images/v2/jgld/jgld_bg1.png',
        info: ['Inspection Assistant is a software application specially applied to the UAS control ground station of Yuandu Technology. It integrates UAS mission planning, real-time flight data monitoring, real-time video monitoring, various load operations, and fine data inspection of mission elevation. The operation interface is simple and easy to use, effectively improving the UAS control efficiency and experience.'],
        ts:['Support route planning for various missions such as waypoint flight and multilateral flight','Support multi-element addition of maps such as point, line and surface, kml, point cloud, etc','Support multi-element addition of maps such as point, line and surface, kml, point cloud, etc','Support multi-machine connection and intelligent control'],
      },
      {
        title: 'Dowell',
        name: '',
        url: '/static/images/v2/rjcp/rj_img2.png',
        bg: '/static/images/v2/jgld/jgld_bg2.png',
        info: ['Dowell is a software application suitable for the portable ground station of UAS for  Aeronitor Technology. The software interface is simple and the function content is comprehensive. It has many functions such as image data integration, mission route planning, real-time video surveillance, multi-machine control, AB point takeoff and landing, etc.'],
        ts:['Equipped with cloud tour live broadcast service, real-time video can be broadcast synchronously',' Support multi-machine control, with A-B remote takeoff and landing function','With data playback function','The interface is simple and easy to operate'],
      },
      {
        title: 'Cloud Patrol',
        name: '',
        url: '/static/images/v2/rjcp/rj_img3.png',
        bg: '/static/images/v2/jgld/jgld_bg2.png',
        info: ['Cloud patrol unattended system is an UAS remote control and management software that can finely classify flight missions and UAS accurate and efficient management. The platform can realize information exchange and sharing, and visually display and intelligently analyze UAS flight data through public or private networks to form a one-stop service chain, providing key support for users\' scientific decision-making.'],
        ts:['Multi-mode and multi-form, real-time dynamic display of UAS status','Real-time remote monitoring and management, drone status control at any time','Support multi-platform and multi-user simultaneous viewing and management','With data playback function'],
      },
    ],
  },
  fzxt:{
    "text1": "Simulation Training System",
    "text2": "The simulated flight training system uses a hardware-in-the-loop simulation framework for sensor data, which can realize the flight training of various UAS in various flight scenarios, and maximize the proximity to real aircraft operations, such as island border inspection, power grid channel inspection, forest fire inspection, etc., to achieve the 3D real scene effect of the whole scene, comprehensively improve the flying hand's proficiency in real flight control, take the lead in familiarizing yourself with the details of flight operations in various fields, and reduce the loss of daily training.",
    "text3": "Highly integrated, complete simulation",
    "text4": "Abandoning the complex structure of the traditional flight emulator, it is highly integrated again, allowing users to obtain a complete and realistic flight simulation exercise.",
    "text5": "A more authentic flight experience",
    "text6": "Using the hardware-in-the-loop simulation framework, sensor data and collision effects are completely simulated in real time by the physical engine, and the upper-level logic application of the system is completely consistent with the real UAS.",
    "text7": "Simulated Flight Training System",
    "text8": "Includes a complete set of avionics and can be flexibly deployed",
    "text9": "(Requires an additional computer)",
    "text10": "Simulated Flight Training System",
    "text11": "High degree of integration, ready to use upon startup",
    "text12": "3D real scene, realistic effect",
    "text13": "UE5 animation rendering images, 3D real simulation, a more realistic environment, multi-perspective experience such as pod perspective, third perspective, top perspective, etc., support the import of scene data for simulation, to give customers a more realistic flight experience and shocking visual effects.",
    "text14": "Support multiple model simulations",
    "text15": "1:1 restores the state of the UAS in the real flight operation, the control response is the same as the real machine, the actual combat state is highly restored, and the simulation switching of various composite, multi-rotor, helicopter and other models is supported.",
    "text16": "The scene is rich and the whole field is covered",
    "text17": "Rich scene selection, island border inspection, power grid channel inspection, fire emergency inspection, fire rescue and reconnaissance, urban security inspection and other multi-field multi-scene experience, and support scene customization, full field coverage.",
    "list": [
      {
        "name": "Support fault and weather conditions stacking",
        "text": "The simulation system can simulate the sudden failure conditions of sensors, as well as set meteorological conditions such as wind, wind direction, rain and snow, and superimpose the real meteorological environment into the emulator to exercise and improve the flying experience of the pilot.",
        "url": "/static/images/v2/fzxt/fz_list2.png"
      },
      {
        "name": "Support swarm flight training",
        "text": "Multiple aircraft can cooperate in a cluster in the same scene, enabling efficient and intelligent operation in complex environments in a virtual state, making reconnaissance training more comprehensive and accurate.",
        "url": "/static/images/v2/fzxt/fz_list3.png"
      },
      {
        "name": "Support job labeling and multiple checks",
        "text": "In a customized scenario, abnormal towers, fire points, and search and rescue personnel can be marked, and the UAS's route, motor steering gear, and takeoff can be inspected and evaluated, and whether the feedback is correct.",
        "url": "/static/images/v2/fzxt/fz_list4.png"
      }
    ]
  },
  yxxt:{
    "text1": "Cloud patrol unattended UAS Docking Station",
    "text2": "The Cloud Patrol Unmanned System is composed of the ZT-13V VTOL fixed-wing UAS and the AH13 VTOL fixed-wing UAS docking station, featuring intelligence, automation, efficiency, and precision. The system has functions such as intelligent storage, remote control, autonomous takeoff and landing, intelligent operation, automatic recovery, automatic charging, data return, and intelligent analysis for the composite-wing drone, enabling autonomous, full-process, and unattended operation of the drone. The ZT-13V composite-wing UAS used in the system has an effective single-sortie flight time of 200 minutes and a maximum inspection length of 180 km. The system can be widely applied in industries such as railways, power, pipelines, mining, forestry and grassland, emergency response, border defense, maritime affairs, and smart cities.",
    "text3": "Parameters",
    "list": [
      {
        "icon": "/static/images/v2/120v/120v_icon1.png",
        "title": "VTOL",
        "info": "It has a composite aerodynamic layout of quadrotor + fixed-wing. It not only has the convenience of vertical takeoff and landing but also the characteristic of long endurance of the fixed-wing, with a endurance time of up to 10 hours."
      },
      {
        "icon": "/static/images/v2/120v/120v_icon2.png",
        "title": "Modular design",
        "info": "The fuselage, wings, and mission loads are all designed in a modular way, which can be disassembled and assembled without tools, allowing for quick assembly and deployment."
      },
      {
        "icon": "/static/images/v2/120v/120v_icon3.png",
        "title": "Ad hoc network data link",
        "info": "It is equipped with a standard 50-100km ad hoc network data link. The UAS supports the 'UAS-UAS relay' technology, and the transmission distance can be extended to over 300km."
      },
      {
        "icon": "/static/images/v2/120v/120v_icon4.png",
        "title": "Anti-countermeasure and anti-interference",
        "info": "Proprietary sensors and closed-loop attitude algorithms enable safe flight in an environment where satellite signals are disturbed or deceived."
      }
    ],
    "paramsList": [
      {
        "title": "Size",
        "info": "length 3.9m * width 2.19m * height 1.6m"
      },
      {
        "title": "Weight",
        "info": "≤1000kg (excluding the aircraft)"
      },
      {
        "title": "Release/recycling time",
        "info": "≤5min"
      },
      {
        "title": "Input power",
        "info": "220V 50Hz"
      },
      {
        "title": "Standby power supply",
        "info": "≥ 4h + 1 recovery"
      },
      {
        "title": "Protection class",
        "info": "IP55, allowing maintenance and cleaning of the hangar enclosure"
      }
    ]
  },
  hyxw:{
    text1:'新闻动态',
    text2:'...查看全文',
    list: [
      {
        title:'航翊科技多款明星成熟装备亮相珠海航展，收获近亿元意向订单！',
        text:'第十五届中国国际航天航空博览会，于2024年11月12日-11月17日在珠海国际航展中心举行，这场受到全球瞩目的“蓝天盛会”，共吸引来自47个国家和地区的1022家企业参展，其中境外展商较上届航展翻倍。中国国际航空航天博览会是唯一由国务院批准的大型国际航展...',
        time:'2024/11/15',
        img:'/static/images/v2/hyxw/xw1.png',
        path:'',
      },
      {
        title:'中国航展 | 航翊科技邀您共赴珠海航展，共享低空经济发展未来',
        text:'航翊科技邀您共赴珠海航展共享低空经济发展未来.',
        time:'2024/11/08',
        img:'/static/images/v2/hyxw/xw2.png',
        path:'',
      },
      {
        title:'四川航翊智云无人直升机亮相2024自贡低空经济发展大会',
        text:'11月1日，由四川省委军民融合办、省经济和信息化厅与自贡市人民政府联合举办的“2024自贡低空经济发展大会”在四川自贡航空产业园举行。此次活动由四川省委军民融合办、四川省经济和信息化厅与自贡市人民政府共同举办。四川省人民政府副省长田庆盈出席会议并致...',
        time:'2024/11/05',
        img:'/static/images/v2/hyxw/xw3.png',
        path:'',
      },
      {
        title:'HW-600H无人直升机参加全国森林草原防灭火新质能力建设实战演练！',
        text:'10月31日，全国森林草原防灭火新质能力建设实战演练成功举办。本次实战演练由国家森林草原防灭火指挥部办公室主办，广东省森林防灭火指挥部办公室、广州市人民政府等单位承办。本次实战演练旨在检验预案，锻炼队伍，磨合机制，强化协同作战能力。航翊科技应...',
        time:'2024/11/04',
        img:'/static/images/v2/hyxw/xw4.png',
        path:'',
      },
      {
        title:'实战砺剑 | 航翊科技HW-600H无人直升机“三断”超视距物资投送能力验证“精准送达“！',
        text:'日前， “三断”情况下无人机物资投送能力测试活动在山东莱芜举行，航翊科技应邀参加本次活动。在“三断”情况下超视距物资运输测试中，航翊科技旗下HW-600H无人直升机是唯一完成载重100kg以上级别测试的机型，整个测试HW-600H表现出色圆满完赛，获得现场领...',
        time:'2024/08/27',
        img:'/static/images/v2/hyxw/xw5.png',
        path:'',
      },
      {
        title:'【政策解读】无人机出口管制措施，航翊科技再获“两用物项和技术出口许可证”！',
        text:'2024年7月31日，商务部、海关总署、中央军委装备发展部联合发布了优化调整无人机出口管制措施的公告，新政策于2024年9月1日起正式施行。相较于2023年第27号和第28号公告，此次调整主要包括以下几个方面变化...',
        time:'2024/08/01',
        img:'/static/images/v2/hyxw/xw6.png',
        path:'',
      }
    ],
  },
  join:{
    "text1": "Company Introduction",
    "text2": "Hangyi Technology focuses on the research and development as well as production of large-load unmanned helicopters and vertical takeoff and landing fixed-wing unmanned aerial vehicles (UAVs), and is committed to providing customers with professional UAV system solutions. The founding team of the company has been engaged in the UAV industry for decades, possessing a series of independent intellectual property rights. It has mastered the core key technologies of UAVs, such as flight control systems, electro-optical pods, remote data links, and AI machine vision. The company has the ability of independent research and development, as well as manufacturing, covering the entire UAV industry chain.",
    "text3": "Hangyi Technology has completed the construction of two locations and three centers in Yanqing, Beijing and Zigong, Sichuan. It has established a base integrating research and development, production, testing, sales, service, and training, covering the entire industry chain. It has comprehensively laid out a series of products including unmanned helicopters, special avionics for UAVs, composite-wing UAVs, and intelligent fire extinguishing bombs. These products are widely applied in various fields such as military industry, police affairs, emergency response, power, border defense, and petroleum, and are sold overseas.",
    "text4": "Headquarters of Hangyi Technology",
    "text5": "Production Base in Zigong, Sichuan",
    "text6": "Production Base in Yanqing, Beijing",
    list: [
      {
        "name": "Full Industry Chain",
        "text": "The team is the only one in the industrial-grade special UAV track that completely masters the key technologies of the entire industry chain, such as flight control, data link, electro-optical pod, and computer vision."
      },
      {
        "name": "All Fields",
        "text": "The company's products can be adapted to loads in all fields and are widely used in many fields such as emergency response, fire protection, border defense, power, petroleum, exploration, and military industry."
      },
      {
        "name": "Over 18 Years",
        "text": "The core team originates from Tsinghua University and has specialized in core technologies such as flight control and pan-tilt for more than 18 years. It has undergone thousands of algorithm iterations and the market tests of hundreds of thousands of products."
      },
      {
        "name": "Autonomous and Controllable",
        "text": "It has the ability of independent research and development and manufacturing, forming a comprehensive hardware and software product system, and the core technologies of industrial UAVs are autonomous and controllable."
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js